
(function ($) {

  // Define a class-like object using jQuery style
  window.FonCartDrawer = {
    productData: [],
    test: function(){
      alert('test');
    },
    init: function(){

        /* Warm the cart cache while the page is still settling. By the time
           anyone adds to cart, _lastCart is populated and the add can render
           optimistically instead of waiting on a /cart.js of its own. */
        FonCartDrawer.getCart();

        FonCartDrawer.clearBottle();
        FonCartDrawer.updateCartCount();
        FonCartDrawer.productData = JSON.parse(document.getElementById('productSellingPlanData').textContent);

        /* Variant thumbnails for the bundle products, keyed by SKU — rendered
           by the drawer snippet from all_products. See bundleThumb(). */
        try {
          var _btEl = document.getElementById('fonBundleThumbs');
          FonCartDrawer.bundleThumbs = _btEl ? JSON.parse(_btEl.textContent) : {};
        } catch (e) { FonCartDrawer.bundleThumbs = {}; }

        // Line-item upsell targets (server-rendered by Liquid, keyed by try-once handle)
        try {
          var _upsellEl = document.getElementById('fonUpsellTargets');
          FonCartDrawer.upsellTargets = _upsellEl ? JSON.parse(_upsellEl.textContent) : {};
        } catch (e) {
          console.error('Upsell targets parse failed:', e);
          FonCartDrawer.upsellTargets = {};
        }

        // Flavour swatch colours keyed by variant SKU.
        // Hardcoded fallback (from the product flavour swatches) so the dot always has a
        // colour even if the Liquid metafield map doesn't resolve; the Liquid map wins.
        var FON_FLAVOUR_COLORS_DEFAULT = {
          // OneFit — Sachet boxes
          'OF-CH-BOX-700-V4.6': '#90635d', // Chocolate Milkshake
          'OF-TC-BOX-700-V4.6': '#fdcd1a', // Tropical Crush
          'OF-VI-BOX-700-V4.6': '#e1ccb3', // Vanilla Ice Cream
          'OF-FV-BOX-700-V4.6': '#e5d2b9', // Plant-Based Vanilla
          'OF-CO-BOX-700-V4.6': '#7d3931', // Plant-Based Cacao
          // OneFit — Pouches
          'OF-CM-PCH-700-V4.6': '#90635d',
          'OF-TC-PCH-700-V4.6': '#fdcd1a',
          'OF-VI-PCH-700-V4.6': '#e1ccb3',
          'OF-FV-PCH-700-V4.6': '#e5d2b9',
          'OF-CO-PCH-700-V4.6': '#7d3931',
          // OneFit V4.7 (onefit-v4-7, Sep 29) — 14 / 28-sachet boxes, 56-serve pouch
          'OF-CH-BOX14-V4.7': '#90635d',
          'OF-CH-BOX28-V4.7': '#90635d',
          'OF-CH-PCH56-V4.7': '#90635d',
          'OF-TC-BOX14-V4.7': '#fdcd1a',
          'OF-TC-BOX28-V4.7': '#fdcd1a',
          'OF-TC-PCH56-V4.7': '#fdcd1a'
        };
        try {
          var _colorsEl = document.getElementById('fonFlavourColors');
          var _liquidColors = _colorsEl ? JSON.parse(_colorsEl.textContent) : {};
          FonCartDrawer.flavourColors = Object.assign({}, FON_FLAVOUR_COLORS_DEFAULT, _liquidColors);
        } catch (e) {
          console.error('Flavour colors parse failed:', e);
          FonCartDrawer.flavourColors = FON_FLAVOUR_COLORS_DEFAULT;
        }

        // Flavour colours keyed by flavour NAME (used for 90-day bundle lines whose SKU
        // differs from the one-time SKUs), plus one-time box/pouch prices (cents).
        FonCartDrawer.onefitFlavourColors = {
          'chocolate milkshake': '#90635d',
          'tropical crush': '#fdcd1a',
          'vanilla ice cream': '#e1ccb3',
          'plant-based vanilla': '#e5d2b9',
          'plant vanilla': '#e5d2b9',
          'plant-based cacao': '#7d3931',
          'plant cacao': '#7d3931'
        };
        // Short names shown on the `.fon-line-flavour` dot line. Keyed by the full
        // variant flavour, lowercased. Anything unmapped renders as-is.
        FonCartDrawer.onefitFlavourShortNames = {
          'chocolate milkshake': 'Chocolate',
          'tropical crush': 'Tropical',
          'vanilla ice cream': 'Vanilla',
          'plant-based vanilla': 'Plant Vanilla',
          'plant vanilla': 'Plant Vanilla',
          'plant-based cacao': 'Plant Cacao',
          'plant cacao': 'Plant Cacao'
        };
        // One-time reference prices (cents) — pulled dynamically from onefit-b / onelife-jar
        // via #fonBundleMeta below. Left at 0 until that resolves (no static prices).
        FonCartDrawer.onefitOneTimeCents = { pouch: 0, box: 0 };
        FonCartDrawer.onelifeOneTimeCents = 0;
        FonCartDrawer.onelifeColor = '';

        // Bundle meta (one-time reference prices + OneLife colour) rendered by Liquid.
        try {
          var _metaEl = document.getElementById('fonBundleMeta');
          var _meta = _metaEl ? JSON.parse(_metaEl.textContent) : {};
          if (_meta.onefitBoxCents)   FonCartDrawer.onefitOneTimeCents.box = _meta.onefitBoxCents;
          if (_meta.onefitPouchCents) FonCartDrawer.onefitOneTimeCents.pouch = _meta.onefitPouchCents;
          if (_meta.onelifeJarCents)  FonCartDrawer.onelifeOneTimeCents = _meta.onelifeJarCents;
          if (_meta.onelifeColor)     FonCartDrawer.onelifeColor = _meta.onelifeColor;
        } catch (e) {
          console.error('Bundle meta parse failed:', e);
        }

        $(document).on('click','.fon-cart-heading-row .fon-cart-close',function(){
          $('body').removeClass('body-fon-cart-drawer');
          FonCartDrawer.trackEvent('cart_drawer_closed');
        });


        $(document).on('change','.fon-qty',function(){
          
          var inputValue = parseInt($(this).val());
          var lineKey = $(this).closest('.fon-line-item-row').data('line-key');
          inputValue = inputValue;

          if (inputValue === 0){
            var $qtyInput = $(this);
            FonCartDrawer.confirmRemove().then(function (ok) {
              if (ok) {
                FonCartDrawer.removeCartItem(lineKey);
              } else {
                $qtyInput.val(1);
              }
            });
          }else{


            var dataMultiple = parseInt($(this).parents('.fon-quantity').data('multiple')) || null;

            // Check if bundle
            var parent = $(this).parents('.fon-line-item-row');
            if (parent.find(".fon-less-btn").hasClass('fon-qty-bundle-btn')){

              // Pass the raw unit count; updateCartBundleItem multiplies once
              // (payload multiplier preferred, data-multiple fallback).
              var bundleID = parent.attr('data-bundle-group-id');
              FonCartDrawer.updateCartBundleItem(bundleID, inputValue, dataMultiple);

            }else{

              if (dataMultiple){ inputValue *= dataMultiple; }
              FonCartDrawer.updateCartItem(lineKey, inputValue);

            }

            
          }
          
        });
      
        $(document).on('click','.fon-line-item-row.fon-line-item-bundle-row .fon-trash-bin',function(){
          

        });

        $(document).on('click','.fon-quantity button.fon-qty-btn',function(){

          if ($(this).hasClass('fon-qty-bundle-btn')){

            var parent = $(this).parents('.fon-line-item-row');
            var bundleID = parent.attr('data-bundle-group-id');
            var input = $(this).siblings('input');
            var inputValue = parseInt(input.val());


           
            var action = $(this).attr('data-action');
        
            // Pass the shown UNIT count; updateCartBundleItem multiplies each line up
            // to its real cart quantity exactly once — preferring the line's own
            // _bundle_group_product_multiplier and falling back to the picker's
            // data-multiple (some lines only define one or the other).
            var dataMultiple = parseInt($(this).parents('.fon-quantity').data('multiple')) || null;

            switch (action){
              case 'minus':

                // <= 1, not === 1: a line that reads 0 (parseInt of "0.6") would
                // otherwise step to -1, the update is refused, and it can't be cleared.
                if (!(inputValue > 1)){
                  FonCartDrawer.confirmRemove().then(function (ok) {
                    if (ok) { FonCartDrawer.updateCartBundleItem(bundleID, 0, dataMultiple); }
                  });
                }else{
                  inputValue--;
                  input.val(inputValue);
                  FonCartDrawer.updateCartBundleItem(bundleID, inputValue, dataMultiple);
                }

              break;
              case 'plus':

                inputValue++;
                input.val(inputValue);
                FonCartDrawer.updateCartBundleItem(bundleID, inputValue, dataMultiple);

              break;
            }


          }else{
            var parent = $(this).parents('.fon-line-item-row');
            
            var input = $(this).siblings('input');
            var inputValue = parseInt(input.val());
            var lineKey = $(this).closest('.fon-line-item-row').data('line-key');
            inputValue = inputValue;
        
            var action = $(this).attr('data-action');
        
            switch (action){
              case 'minus':
                
                
                if (inputValue === 1){
                  FonCartDrawer.confirmRemove().then(function (ok) {
                    if (ok) { FonCartDrawer.removeCartItem(lineKey); }
                  });
                }else{
                  inputValue--;
                  input.val(inputValue);
                  FonCartDrawer.updateCartItem(lineKey, inputValue);
                }
                
              break;
              case 'plus':

                /* A CAPPED LINE (2026-10-06, the VIP lander: "max 3 per person").
                   v88-buybox.js adds it with _max_qty; the cap counts every line
                   of that variant, so + stops once they reach it. */
                var capCart = FonCartDrawer._lastCart;
                var capItem = capCart && (capCart.items || []).filter(function (it) { return it.key === lineKey; })[0];
                var capMax = capItem && capItem.properties ? parseInt(capItem.properties._max_qty, 10) : 0;
                if (capMax > 0) {
                  var capHave = 0;
                  capCart.items.forEach(function (it) { if (it.variant_id === capItem.variant_id) capHave += it.quantity; });
                  if (capHave >= capMax) {
                    $(this).attr('title', 'Max ' + capMax + ' per person');
                    break;
                  }
                }

                inputValue++;
                input.val(inputValue);
                FonCartDrawer.updateCartItem(lineKey, inputValue);

              break;
            }

            if (parent.find('.fon-line-item-subscribe-save.active').length){
              
            }

            
          }
      
          
        });
      
       
        // Convert to Monthly - New Cart
        $(document).on('click', '.fon-line-item-wrapper button.btn-upgrade-bundle', function () {

          $('body').addClass('fon-cart-drawer-updating');

          var $thisBtn = $(this);
          $thisBtn.html('Upgrading...');

          var $row = $(this).closest('.fon-line-item-row');
          var bundleGroupID = $row.attr('data-bundle-group-id');
          
          let inclusions = [];
          
          // 1️⃣ Collect variants and new selling plans
          $row.find('.inclusion-variant').each(function() {
            inclusions.push({
              plan_id: parseInt($(this).attr('data-plan-id')),
              variant_id: parseInt($(this).attr('data-variant-id')),
              quantity: parseInt($(this).attr('data-quantity')),
            });
          });

          console.log('inclusions', inclusions);

          // 2️⃣ Fetch the current cart
          FonCartDrawer.getCart().then(function(cart) {
            let itemsToRemove = [];
            let itemsToAdd = [];

            // 3️⃣ Find bundle items
            $.each(cart.items, function(i, item) {
              if (item.properties && item.properties._bundle_group_id == bundleGroupID) {
                const inclusion = inclusions.find(inc => inc.variant_id == item.variant_id);
                if (inclusion) {
                  itemsToRemove.push(item.key);

                  // Copy all properties
                  let newProps = $.extend(true, {}, item.properties);
                  // Conversion tracking: lands on the order's line items (hidden at checkout)
                  newProps._cart_drawer_action = 'upgrade-to-subscription';
                  newProps._cart_drawer_description = 'upgraded ' + (item.properties._BUNDLE || item.product_title) + ' to subscription via cart drawer';
                  if (!window.__fonUpgradeFrom) window.__fonUpgradeFrom = {};
                  window.__fonUpgradeFrom[bundleGroupID] = item.properties._BUNDLE || item.product_title;

                  // 4️⃣ Build re-add object
                  itemsToAdd.push({
                    id: item.variant_id,
                    quantity: inclusion.quantity || item.quantity,
                    selling_plan:inclusion.plan_id,
                    properties: newProps
                  });
                }
              }
            });

            if (!itemsToAdd.length) {
              console.warn('No matching bundle items found to update.');
              $thisBtn.html('Upgrade');
              $('body').removeClass('fon-cart-drawer-updating');
              return;
            }

            // 🔁 Helper: remove one by one sequentially
            function removeItemsSequentially(keys, index = 0) {
              if (index >= keys.length) return $.Deferred().resolve().promise();
              return $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: { id: keys[index], quantity: 0 },
                dataType: 'json'
              }).then(function() {
                // Chain next removal
                return removeItemsSequentially(keys, index + 1);
              });
            }

            // 5️⃣ Remove bundle items sequentially, then add back
            removeItemsSequentially(itemsToRemove).then(function() {
              console.log('All old bundle items removed, adding new ones...');
              return $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify({ items: itemsToAdd }),
                contentType: 'application/json',
                dataType: 'json'
              });
            }).done(function(updatedCart) {
              FonCartDrawer.trackEvent('cart_drawer_conversion', {
                drawer_action: 'upgrade-to-subscription',
                from_product: (window.__fonUpgradeFrom || {})[bundleGroupID] || 'bundle',
                to_product: 'subscription'
              });
              console.log('✅ Bundle converted successfully:', updatedCart);
              $thisBtn.html('Upgrade');
            
              if (window.FonCartDrawer && FonCartDrawer.updateCartDrawer) {
                FonCartDrawer.updateCartDrawer();
              } else {
                location.reload();
              }
            }).fail(function(err) {
              console.error('❌ Error converting bundle:', err);
              $thisBtn.html('Upgrade');
              $('body').removeClass('fon-cart-drawer-updating');
            });
          });
        });




        $(document).on('click', '.fon-line-item-wrapper button.btn-upgrade', function () {

          $('body').addClass('fon-cart-drawer-updating');

          var $row = $(this).parents('.fon-line-item-row');
          
      
          var lineKey = $row.data('line-key'); // from cart.item.key
          var sellingPlanId = $(this).data('plan-id');
          var quantity = parseInt($row.find('.fon-qty').val(), 10) || 1;
        
          if (!lineKey || !sellingPlanId || quantity < 1) {
            console.warn('Missing lineKey, sellingPlanId, or invalid quantity');
            return;
          }
        
          // Update cart item
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              id: lineKey,
              quantity: quantity,
              selling_plan:sellingPlanId
            },
            success: function (cart) {
              console.log('Updated selling plan:', cart);
              FonCartDrawer.updateCartDrawer(); // Refresh the UI
            },
            error: function (err) {
              console.error('Failed to update cart item:', err);
            }
          });
          

        });


        // Convert to Monthly
        $(document).on('click', '.fon-save-option .fon-toggle-box, .fon-save-option .fon-badge', function () {

          $('body').addClass('fon-cart-drawer-updating');

          var $clickedOption = $(this).parents('.fon-save-option');
          var $row = $clickedOption.closest('.fon-line-item-row');
          
          if ($clickedOption.hasClass('fon-save-option-12-months')){
            
            
              var lineKey = $row.attr('data-line-key');
              var quantity = $clickedOption.attr('data-quantity');
              var variantID = $clickedOption.attr('data-variant-id');
              var sellingPlanID = $clickedOption.attr('data-selling-plan-id');
            

              FonCartDrawer.swapCartItem(lineKey,variantID,quantity,sellingPlanID);
              
            
          }else{

              // Regular selling plan
         
              // Toggle active state
              $row.find('.fon-save-option').removeClass('active');
              $clickedOption.addClass('active');
            
              // Get data
              var lineKey = $row.data('line-key'); // from cart.item.key
              var sellingPlanId = $clickedOption.data('selling-plan-id');
              var quantity = parseInt($row.find('.fon-qty').val(), 10) || 1;
            
              if (!lineKey || !sellingPlanId || quantity < 1) {
                console.warn('Missing lineKey, sellingPlanId, or invalid quantity');
                return;
              }
            
              // Update cart item
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                  id: lineKey,
                  quantity: quantity,
                  selling_plan:sellingPlanId
                },
                success: function (cart) {
                  console.log('Updated selling plan:', cart);
                  FonCartDrawer.updateCartDrawer(); // Refresh the UI
                },
                error: function (err) {
                  console.error('Failed to update cart item:', err);
                }
              });
          }

          

        });

        
    },
    updateCartBundleItem: function(bundleID,quantity,fallbackMultiplier){
      $('body').addClass('fon-cart-drawer-updating');
      FonCartDrawer.getCart().then(function(cart) {
        let updates = {};

        // Build an updates object where bundled items have quantity = 0
        $.each(cart.items, function(i, item) {


          if (item.properties && item.properties._bundle_group_id && item.properties._bundle_group_id == bundleID) {

            // Multiply the base unit qty up exactly once: prefer the line's own
            // multiplier, else the picker's data-multiple fallback, else 1.
            var mult = 1;
            if (item.properties._bundle_group_product_multiplier) {
              mult = parseInt(item.properties._bundle_group_product_multiplier);
            } else if (fallbackMultiplier) {
              mult = parseInt(fallbackMultiplier);
            }

            updates[item.key] = quantity * mult;
          }


        });

        // If there are any items to remove, send one bulk update
        if (Object.keys(updates).length > 0) {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { 
              updates: updates,
              discount : '',
            },
            dataType: 'json',
            success: function() {
              // Once done, refresh your custom cart drawer
              FonCartDrawer.updateCartDrawer();
            }
          });
        } else {
          // No bundled items found — just refresh drawer
          FonCartDrawer.updateCartDrawer();
        }
      });
    },
    /* GA4 event — mirrors the fon-quiz-figma.js track() pattern. Fires gtag
       when present, else queues on dataLayer for GTM; analytics must never
       break the drawer. */
    trackEvent: function (eventName, params) {
      params = params || {};
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', eventName, params);
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: eventName }, params));
        }
      } catch (e) { /* analytics must not break the drawer */ }
    },

    swapCartItem: async function(oldItemKey, newVariantId, quantity = 1, sellingPlanId = null) {
      try {
        // Conversion tracking: resolve what the shopper had BEFORE we remove it
        let swapFromDesc = '';
        try {
          const cartBefore = await FonCartDrawer.getCart();
          const oldLine = (cartBefore.items || []).find(i => i.key === oldItemKey);
          if (oldLine) {
            swapFromDesc = oldLine.product_title + (oldLine.variant_title && oldLine.variant_title !== 'Default Title' ? ' (' + oldLine.variant_title + ')' : '');
          }
        } catch (e) { /* tracking is best-effort */ }

        // 1. Remove old item
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: oldItemKey,
            quantity: 0
          })
        });
        FonCartDrawer.invalidateCart();  /* fetch() bypasses the ajax hook */
    
        // 2. Prepare add payload
        const addPayload = {
          id: newVariantId,
          quantity: quantity,
          properties: {
            _cart_drawer_action: 'save-option-12-months',
            _cart_drawer_description: 'switched ' + (swapFromDesc || 'item') + ' to 12-month subscription via cart drawer'
          }
        };
    
        if (sellingPlanId) {
          addPayload.selling_plan = sellingPlanId;
        }
    
        // 3. Add new product (with optional selling plan)
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(addPayload)
        });
        FonCartDrawer.invalidateCart();  /* fetch() bypasses the ajax hook */
    
        if (!addResponse.ok) {
          const errorText = await addResponse.text();
          throw new Error('Add failed: ' + errorText);
        }

        FonCartDrawer.trackEvent('cart_drawer_conversion', {
          drawer_action: 'save-option-12-months',
          from_product: swapFromDesc || 'item',
          to_product: '12-month subscription'
        });
    
        const addedItem = await addResponse.json();
    
        // ✅ 4. Trigger next step
        console.log('Swap complete:', addedItem);
        FonCartDrawer.updateCartDrawer(); // Refresh the UI
        
    
      } catch (error) {
        console.error('Swap failed:', error);
      }
    },
    clearFreeItems: function(variantIds = [], label = 'Item') {
      FonCartDrawer.getCart().then(function(cart) {


        // var discountCode = '';
        // // 🔍 Check if any item has a property containing 'BUNDLE'
        // const bundleItems = cart.items.filter(item => {
        //   if (item.properties) {
        //     return Object.keys(item.properties).some(
        //       key => key.toUpperCase().includes('BUNDLE') ||
        //             String(item.properties[key]).toUpperCase().includes('BUNDLE')
        //     );
        //   }
        //   return false;
        // });

        // if (bundleItems.length > 0) {
        //   let names = bundleItems.map(i => i.title).join(', ');
        //   alert('BUNDLE item(s) found in cart: ' + names);
        // }else{
        //     alert('NO BUNDLE');
          
        //       // 🏷️ Get all discount codes from the cart
        //     const discountCodes = cart.discount_codes || [];

        //     // 🧹 Clean up codes: remove "Pouch and Sachets / Subscription"
        //     const filteredDiscounts = discountCodes
        //       .map(d => d.code || d) // normalize to string
        //       .filter(code => code.toUpperCase() !== 'POUCH AND SACHETS / SUBSCRIPTION');

        //     // 🎯 Return only the first code if multiple exist
        //     discountCode = filteredDiscounts.length > 1 ? filteredDiscounts[0] : filteredDiscounts[0] || '';
              

        // }


        let itemsToRemove = cart.items.filter(i => variantIds.includes(i.variant_id));
        
        if (itemsToRemove.length > 0) {
          // Build updates: set quantity to 0 for each matching item
          let updates = {};
          itemsToRemove.forEach(item => {
            updates[item.key] = 0;
          });

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              // discount: discountCode,
              updates: updates
            },
            dataType: 'json',
            success: function(updatedCart) {
              console.log(label + '(s) removed directly:', variantIds);
            },
            error: function(err) {
              console.error('Error removing ' + label + '(s):', err);
            }
          });
        } else {
          console.log(label + '(s) not in the cart — skipping removal.');
        }
      });
    },
    clearBottle: function(){
      FonCartDrawer.clearFreeItems([53301741289656, 51843757670584,51793029103800,52304276357304,52304251027640,52219844985016,53491544391864,52887363551416].concat(FonCartDrawer.GIFT_EXTRA_IDS), 'Free Gift');

      //51793029103800 == e-book
      // FonCartDrawer.getCart().then(function(cart) {
      //   let bottleItem = cart.items.find(item => item.variant_id === 53301741289656);
        
      //   if (bottleItem) {
      //     $.ajax({
      //       type: 'POST',
      //       url: '/cart/change.js',
      //       data: {
      //         id: bottleItem.key, // safer to use item key
      //         quantity: 0
      //       },
      //       dataType: 'json',
      //       success: function(updatedCart) {
      //         console.log('Bottle removed directly.');
      //       },
      //       error: function(err) {
      //         console.error('Error removing bottle:', err);
      //       }
      //     });
      //   } else {
      //     console.log('Bottle is not in the cart — skipping removal.');
      //   }
      // });
    },
    // clearBottle: function(){
    //   $.ajax({
    //       type: 'POST',
    //       url: '/cart/change.js',
    //       data: {
    //         id: 53301741289656,
    //         quantity: 0
    //       },
    //       dataType: 'json',
    //       success: function(updatedCart) {
    //         console.log('Variant removed directly.');
    //         // Optionally refresh the cart UI
    //       },
    //       error: function(err) {
    //         console.error('Error:', err);
    //       }
    //   });
      
    // },
    /* ---- Free gifts ------------------------------------------------------
       Gift variant IDs, and the per-bundle entitlements (see CLAUDE.md).
       `div` turns the anchor line's quantity into a bundle count; `of` gifts
       come from the OneFit listing, `ol` from the OneLife one. */
    GIFT_VARIANTS: {
      bottle:    53301741289656,   // regular bottle
      frother:   51843757670584,   // regular frother
      olBottle:  53301741289656,   // OneLife slot now uses the regular bottle (was 53491544391864, an OL-only shipping-name variant)
      olFrother: 51843757670584,   // OneLife slot now uses the regular frother (was 52887363551416, an OL-only shipping-name variant)
      /* The V4.7 Subscribe & Save gifts (2026-10-14, on request: "use these
         fon-premium-frother / fon-script-cap"). Their own products, with their
         own stock flags in layout/theme.liquid (premiumFrotherOOS, capOOS). */
      premiumFrother: 53493540225208, // FON Premium Frother, FON-FR-02
      cap:            53481755050168  // FON Script Cap, FON-HAT-01
    },

    /* The newer gift variants, appended to each of the drawer's three
       hand-kept clear-lists (clearBottle, updateCartDrawer, the checkout
       handler) so a gift line is cleared before it is re-added, as the
       bottle and frother always were. */
    GIFT_EXTRA_IDS: [53493540225208, 53481755050168],

    /* A rule's per-SKU exception (GIFT_RULES.*.bySku), or null. Shared by
       computeFreeGifts and the render, so the two never disagree. */
    skuRule: function (rule, sku) {
      return (rule && rule.bySku && rule.bySku.re.test(sku || '')) ? rule.bySku : null;
    },

    /* One order earns each gift once (2026-10-15, Renz: "1 lang ... If may mag
       order ng 10, 10 freebies agad"). Quantity no longer multiplies gifts:
       each total is capped at what ONE bundle in the cart grants, so
       comprehensive's 2 bottles and For Two's 2 of each still stand, or at 1
       for a gift no rule names (the drawer's non-bundle monthly bottle).
       Applied to computeFreeGifts and to the render's totals, so the drawer
       and checkout agree. */
    capGifts: function (totals, cart) {
      var ceil = { bottle: 0, frother: 0, olBottle: 0, olFrother: 0, premiumFrother: 0, cap: 0 };
      ((cart && cart.items) || []).forEach(function (item) {
        var props = item.properties || {};
        if (!props._BUNDLE) return;
        var rule = FonCartDrawer.GIFT_RULES[String(props._BUNDLE).replace(/^unicorn_/, '')];
        if (!rule) return;
        var skuRule = FonCartDrawer.skuRule(rule, item.sku);
        var ofGifts = skuRule ? skuRule.of : rule.of;
        if (ofGifts) {
          ceil.bottle  = Math.max(ceil.bottle,  ofGifts.b);
          ceil.frother = Math.max(ceil.frother, ofGifts.f);
        }
        if (skuRule) {
          ceil.premiumFrother = Math.max(ceil.premiumFrother, skuRule.pf || 0);
          ceil.cap            = Math.max(ceil.cap,            skuRule.cap || 0);
        }
        if (rule.ol) {
          ceil.olBottle  = Math.max(ceil.olBottle,  rule.ol.b);
          ceil.olFrother = Math.max(ceil.olFrother, rule.ol.f);
        }
        if (rule.cap) ceil.cap = Math.max(ceil.cap, rule.cap);
      });
      Object.keys(ceil).forEach(function (k) {
        totals[k] = Math.min(Number(totals[k]) || 0, Math.max(1, ceil[k]));
      });
      return totals;
    },

    /* Whether a newer gift can go in the cart right now. Its flag comes from
       layout/theme.liquid; a page without the flag adds nothing, because one
       refused variant fails the whole /cart/add.js batch and takes the other
       gifts down with it. */
    giftAddable: function (flagName) {
      return typeof window[flagName] !== 'undefined' && window[flagName] === false;
    },

    /* Bottle gifts are ON again (2026-09-15). They were switched off on
       2026-09-04 while the clear bottle was out of stock, and the PDP copy was
       hidden to match; stock is back, so both come back together. The switch
       stays because it is the one lever that neutralises every bundle arm's
       hardcoded accumulator without editing fourteen switch cases — enforced at
       the two places totals are consumed, the render's freeGiftTotals and
       computeFreeGifts. Frothers were never affected either way.

       Flip to true to suppress bottle gifts again — and if you do, hide the PDP
       copy with it, or the pages promise a gift the cart will not add. The
       runtime `bottleOOS` gate only stops the line being added; it does not
       touch the copy. */
    BOTTLE_GIFTS_DISABLED: false,

    /* Frother gifts are OFF (2026-09-22). Same lever as the bottle switch above,
       enforced at the same two places totals are consumed (the render's
       freeGiftTotals and computeFreeGifts), so every bundle arm's frother count
       in GIFT_RULES is neutralised without editing the rules themselves - they
       are left as they were so switching back is one flag.

       TO RESTORE: set this to false, AND undo the copy hidden with it, which is
       marked "frother gift hidden 2026-09-22" wherever it was taken off:
         snippets/product-info-onefit-all-jan-2026-b-shorter.liquid  (kit line, 60-day line, kit photos)
         snippets/product-info-onelife-jar-offers.liquid             (kit line, kit photo)
         snippets/product-info-comprehensive.liquid                  (4 welcome-kit lines)
         snippets/product-info-comprehensive-short.liquid            (kit line, kit photo, 3 lines)
         sections/fon-section-comprehensive-all(-short).liquid       (the 1x FON Frother card)
         sections/section-onefit-31-in-1.liquid                      (gift card, menu tile, plan line)
         snippets/fon-onefit-90d-upsell.liquid, fon-onelife-90d-upsell.liquid  ("Luxury Bottle & Mixer")
         sections/fon-section-conquesting-buy.liquid                 (onefit-vs-* pages, 2 lines)
         sections/fon-section-onelife-conquesting-buy.liquid         (onelife-vs-* pages, 2 lines)
         sections/fon-section-onelife-hybrid-buy.liquid              (hybrid page, 2 lines)
         sections/fon-im-special-offer-gift-product.liquid           (1 line, + its 2 adds)
         snippets/product-info-onefit-all-jan-2026-b.liquid          (1 line)
         snippets/product-info-onelife-jar.liquid                    (?view=onelife-jar-2026-shorter: 2 kit lines, 2 photos)
         snippets/product-info-onelife-all-jan-2026(-shorter,-nmn).liquid  (kit lines/photos, "Free Frother", 2x line)
         sections/section-onefit-system.liquid, section-onefit-plant.liquid  (mobile menu "Bottle & Frother")
       Swapped photos keep the original URL in a data-frother-photo-was attribute.
       and the pages that add a frother WITHOUT this engine (search the same
       marker): the four angle landers' FROTHER_QTY, and the special-offer
       welcome / checkout-redirect adds.

       One place cannot carry the marker, because it is JSON: the FAQ answer
       "What's included with Subscribe & Save?" had
         <li>Free FON Frother with second delivery</li>
       removed from 13 templates (product.onelife-*, product.ol-google, and the
       page.fon-*-vs-* / page.fon-hybrid-onelife comparison pages). Restoring
       means putting that item back in each.

       Flip the flag alone and the pages stay silent about a gift the cart is
       giving again. */
    /* (develop -> main sync, 2026-10-14) This switches off the OLD free frother
       (fon-frother-free) only. The V4.7 Subscribe & Save gifts --
       premiumFrother and cap, GIFT_RULES.onefit_30d.bySku -- are separate keys
       and are not touched by it. */
    FROTHER_GIFTS_DISABLED: true,

    GIFT_RULES: {
      onefit_90d:            { div: 5,    of: { b: 1, f: 1 } },
      onefit_60d:            { div: 3,    of: { b: 1, f: 1 } },
      // bottle on the first delivery, no frother. V4.7 lines differ (2026-10-14,
      // on request): no bottle ("bottle should be hidden"), and instead the
      // FON Premium Frother and the FON Script Cap ("use these"), which is
      // what the V88 4.7 page's first-order list promises. The V4.6 landers
      // that share onefit_30d still promise a bottle, so the exception goes by
      // SKU, not by bundle. pf / cap are per bundle, like b / f.
      onefit_30d:            { div: 1,    of: { b: 1, f: 0 },
                               bySku: { re: /-V4\.7$/i, of: { b: 0, f: 0 }, pf: 1, cap: 1 } },
      onefit_90d_conquesting:{ div: 5,    of: { b: 1, f: 1 }, useGroupQty: true },
      comprehensive_90d:     { div: null, ol: { b: 2, f: 1 } },  // div = the anchor's own multiplier
      comprehensive_365d:    { div: 19,   ol: { b: 2, f: 2 } },
      comprehensive_30d:     { div: 2,    ol: { b: 1, f: 1 } },
      comprehensive_1m:      { div: 2,    ol: { b: 1, f: 1 } },  // one-time, same gifts as the recurring 30d
      onelife_90d:           { div: 3,    ol: { b: 1, f: 1 } },
      onelife_90d_duo:       { div: 6,    ol: { b: 2, f: 2 } },
      // OneLife launch gifts (2026-11-02, Akaash: "1 gift for sub only ... 2
      // gifts for double", "duo is 1x bottle and 1x hat"). For One earns the
      // bottle; For Two (two jars on one delivery) the bottle and the FON
      // Script Cap -- the cap is a rule-level key here, as V4.7's is per SKU.
      // No frother on either. The V88 first-order list shows the same.
      onelife_60d:           { div: 2,    ol: { b: 1, f: 0 }, cap: 1 },  // 2 jars per delivery
      onelife_30d:           { div: 1,    ol: { b: 1, f: 0 } },
      onelife_onetime:       { div: 1,    ol: { b: 1, f: 1 }, flat: true }
    },

    /* Free-gift totals for a cart, derived purely from its line-item properties.
       Mirrors the accumulation the drawer does while rendering, so the drawer and
       a drawer-less checkout can never disagree. Legacy `unicorn_*` _BUNDLE values
       fall through to their base rule. */
    computeFreeGifts: function (cart) {
      var totals = { bottle: 0, frother: 0, olBottle: 0, olFrother: 0, premiumFrother: 0, cap: 0 };
      var seenGroups = {};

      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        var bundle = props._BUNDLE;
        if (!bundle) return;

        // Legacy carts: unicorn_comprehensive_90d -> comprehensive_90d
        var key = String(bundle).replace(/^unicorn_/, '');
        var rule = FonCartDrawer.GIFT_RULES[key];
        if (!rule) return;

        // A bundle group spans several lines; only the anchor grants gifts.
        var gid = props._bundle_group_id;
        if (gid) {
          if (seenGroups[gid]) return;
          seenGroups[gid] = true;
        }

        var bundles;
        if (rule.flat) {
          bundles = item.quantity;
        } else if (rule.useGroupQty) {
          // Conquesting anchors on the group's combined quantity, not one line's.
          var groupQty = 0;
          (cart.items || []).forEach(function (i) {
            var p = i.properties || {};
            if (gid && p._bundle_group_id === gid && p._bundle_group_product_row) groupQty += i.quantity;
          });
          bundles = (groupQty || item.quantity) / rule.div;
        } else {
          var div = rule.div || parseInt(props._bundle_group_product_multiplier) || 5;
          bundles = item.quantity / div;
        }
        bundles = Math.round(bundles);
        if (!bundles || bundles < 0) return;

        var skuRule = FonCartDrawer.skuRule(rule, item.sku);
        var ofGifts = skuRule ? skuRule.of : rule.of;
        if (ofGifts) {
          totals.bottle  += bundles * ofGifts.b;
          totals.frother += bundles * ofGifts.f;
        }
        if (skuRule) {
          totals.premiumFrother += bundles * (skuRule.pf || 0);
          totals.cap            += bundles * (skuRule.cap || 0);
        }
        if (rule.ol) {
          totals.olBottle  += bundles * rule.ol.b;
          totals.olFrother += bundles * rule.ol.f;
        }
        if (rule.cap) totals.cap += bundles * rule.cap;
      });

      if (FonCartDrawer.BOTTLE_GIFTS_DISABLED) { totals.bottle = 0; totals.olBottle = 0; }
      if (FonCartDrawer.FROTHER_GIFTS_DISABLED) { totals.frother = 0; totals.olFrother = 0; }
      if (FonCartDrawer.usOnly()) { totals = { bottle: 0, frother: 0, olBottle: 0, olFrother: 0, premiumFrother: 0, cap: 0 }; }
      return FonCartDrawer.capGifts(totals, cart);
    },

    /* US = OneLife only (snippets/fon-us-only, 2026-10-07): OneLife USA ships
       from the US 3PL with no free gifts, so a US-market cart earns none. */
    usOnly: function () {
      return !!(document.body && document.body.classList.contains('fon-us-only'));
    },

    /* The gift lines to POST to /cart/add.js, stock-gated. */
    /* Gift lines to POST, stock-gated, and net of whatever gift quantity the cart
       already holds — otherwise a second checkout click doubles them up. */
    giftLineItems: function (gifts, cart) {
      var v = FonCartDrawer.GIFT_VARIANTS;
      var oosBottle  = (typeof bottleOOS  !== 'undefined') && bottleOOS;
      var oosFrother = (typeof frotherOOS !== 'undefined') && frotherOOS;

      var already = {};
      ((cart && cart.items) || []).forEach(function (i) {
        already[i.variant_id] = (already[i.variant_id] || 0) + i.quantity;
      });

      var want = [
        { id: v.bottle,    qty: Number(gifts.bottle),    oos: oosBottle  },
        { id: v.frother,   qty: Number(gifts.frother),   oos: oosFrother },
        { id: v.olBottle,  qty: Number(gifts.olBottle),  oos: oosBottle  },
        { id: v.olFrother, qty: Number(gifts.olFrother), oos: oosFrother },
        { id: v.premiumFrother, qty: Number(gifts.premiumFrother || 0), oos: !FonCartDrawer.giftAddable('premiumFrotherOOS') },
        { id: v.cap,            qty: Number(gifts.cap || 0),            oos: !FonCartDrawer.giftAddable('capOOS') }
      ];

      var items = [];
      want.forEach(function (w) {
        if (w.oos || !(w.qty > 0)) return;
        var missing = w.qty - (already[w.id] || 0);
        if (missing > 0) items.push({ id: w.id, quantity: missing });
      });
      return items;
    },

    /* Add the cart's free gifts, then go straight to checkout — no drawer.
       Used by the unicorn pages, whose own CSS conflicts with the drawer's.

       Every path ends at /checkout: the bundle is already in the cart by the
       time we get here, so a failed gift add must never strand the shopper on a
       dead button. `onError` only fires when we did NOT navigate. */
    checkoutWithGifts: function (onError) {
      var go = function () { window.location.href = '/checkout'; };

      /* force:true — checkout is the one moment a stale cart turns into a
         wrong order. The cache can go stale in ways the hooks can't see (the
         back button restoring this page after a purchase, another tab, an app
         mutating the cart through its own copy of jQuery or raw XHR), and the
         gift math below posts against line keys from whatever cart this
         returns. The old code always fetched fresh here; keep that. */
      var request = FonCartDrawer.getCart(true);

      request.done(function (cart) {
        var itemsToAdd;
        try {
          itemsToAdd = FonCartDrawer.giftLineItems(FonCartDrawer.computeFreeGifts(cart), cart);
        } catch (e) {
          console.error('[FonCartDrawer] free-gift calc threw', e);
          go();                       // ship the order; the gifts are the lesser loss
          return;
        }

        if (!itemsToAdd.length) { go(); return; }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: itemsToAdd }),
          dataType: 'json',
          contentType: 'application/json',
          success: go,
          error: function (err) {
            console.error('[FonCartDrawer] free-gift add failed', err && err.responseText);
            go();
          }
        });
      });

      /* Only a failed /cart.js leaves them on the page — nothing was changed, so
         restoring the button is the right call. */
      request.fail(function (err) {
        console.error('[FonCartDrawer] /cart.js failed', err && err.status, err && err.responseText);
        if (typeof onError === 'function') onError(err);
      });
    },

    // Single source of truth for "how many items are in the cart": the nav badge
    // and the drawer's "Your Cart (N)" heading must never disagree. A bundle
    // group counts once however many lines it spans; everything else counts once.
    /* The line's own variant image, by SKU, with a hardcoded fallback for
       carts rendered before fonBundleThumbs existed (or unknown SKUs). */
    bundleThumb: function (sku, fallback) {
      return (FonCartDrawer.bundleThumbs && FonCartDrawer.bundleThumbs[sku]) || fallback;
    },

    /* The plan label for a line, taken from the line itself.
       Bundle rows used to hardcode this, which held while every bundle had
       exactly one plan behind it. The weekly-cadence test breaks that: the same
       onefit_30d bundle now ships on "Every 4 Weeks", "Every 6 Weeks" or
       "Every 8 Weeks", so a hardcoded label tells three quarters of those
       customers the wrong delivery schedule.
       'Ships every 30-days' keeps its friendlier wording, the same swap the
       non-bundle rows already make, so nothing that reads right today changes. */
    planLabel: function (item, fallback) {
      var alloc = item && item.selling_plan_allocation;
      var name = alloc && alloc.selling_plan ? alloc.selling_plan.name : '';
      if (!name) return fallback || 'One-time Purchase';
      return name === 'Ships every 30-days' ? 'Monthly Delivery' : name;
    },

    countCartLineItems: function (cart) {
      var seenBundles = {};
      var count = 0;
      cart.items.forEach(function (i) {
        var gid = i.properties && i.properties._bundle_group_id;
        if (gid) {
          if (!seenBundles[gid]) {
            seenBundles[gid] = true;
            count += 1;
          }
        } else {
          count += 1;
        }
      });
      return count;
    },

    // Paint the nav badge from an already-fetched cart (no extra request).
    renderCartCount: function (cart) {
      var itemCount = FonCartDrawer.countCartLineItems(cart);
      $('.cart-count-badge').text(itemCount);
      if (itemCount === 0) {
        $('.cart-count-badge').hide();
      } else {
        $('.cart-count-badge').show();
      }
    },

    updateCartCount: function(){
      FonCartDrawer.getCart().then(function(cart) {
        FonCartDrawer.renderCartCount(cart);
      });
    },

    updateCartItem: function (lineKey, quantity) {

      $('.fon-qty-btn').prop('disabled',true);
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: lineKey,
          quantity: quantity
        },
        dataType: 'json',
        success: function (cart) {
          $('.fon-qty-btn').prop('disabled',false);
          FonCartDrawer.updateCartDrawer(); // Refresh the UI
        },
        error: function (err) {
          console.error('Failed to update cart item:', err);
          $('.fon-qty-btn').prop('disabled',false);
        }
      });
    },

    removeCartItem: function(lineKey) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: lineKey, // use line item key instead of variant ID
          quantity: 0
        },
        dataType: 'json',
        success: function(cart) {
          FonCartDrawer.updateCartDrawer();
        },
        error: function(err) {
          console.error('Failed to remove item:', err);
        }
      });
    },
    // Styled replacement for window.confirm(): resolves true/false when the user
    // clicks Remove / Cancel (or the overlay). Falls back to native confirm.
    confirmRemove: function (message) {
      return new Promise(function (resolve) {
        var $modal = $('#fon-confirm-modal');
        if (!$modal.length) {
          resolve(window.confirm(message || 'Remove this item?'));
          return;
        }
        $modal.find('.fon-confirm-message').text(message || 'Remove this item from your cart?');
        $modal.addClass('active').attr('aria-hidden', 'false');

        function close(result) {
          $modal.removeClass('active').attr('aria-hidden', 'true');
          $modal.off('.fonConfirm');
          resolve(result);
        }
        $modal.on('click.fonConfirm', '.fon-confirm-yes', function () { close(true); });
        $modal.on('click.fonConfirm', '.fon-confirm-no, .fon-confirm-overlay', function () { close(false); });
      });
    },

    /* `pending` marks a PRE-EMPTIVE open — the drawer is being shown on click,
       before /cart/add.js has returned. While that is true the empty-cart state
       must not render: the cart is legitimately empty for ~1.1s, but telling the
       shopper so, moments after they added something, is wrong and then flips.
       Cleared as soon as a render has items, or if the add fails. */
    /* ----------------------------------------------------------------------
       WHEN THE DRAWER OPENS

       It opens once the line that was just added is on screen — not on click,
       not on a timer, not when /cart/add.js answers. Everything else was
       visible as a blink: the drawer slid in over a placeholder, or over the
       previous cart, and the real contents swapped in afterwards while the
       customer watched.

       So an add no longer opens anything. updateCartDrawer() records the keys
       the add returned, openCartDrawer() holds off while they are outstanding,
       and the render calls flushDeferredOpen() once those keys are in the DOM.
       The drawer's first frame is therefore its final one.
       ---------------------------------------------------------------------- */

    /* An open was asked for while an add was in flight. */
    _openWhenRendered: false,

    /* Line keys from an add that have not been rendered yet. */
    _awaitingKeys: null,
    _awaitTimer: null,

    /* Adds in flight, counted at the ajax/fetch layer. A counter, not a
       boolean: with two rapid adds, the first one finishing must not end the
       pending window while the second is still running. */
    _addsInFlight: 0,

    /* Bridges the gap between the click and its /cart/add.js actually being
       sent (same tick on every PDP, but a handler that throws in between
       would otherwise leave us pending forever — hence the expiry). */
    _clickPending: false,
    _clickPendingTimer: null,

    /* True while an add is somewhere between click and completion. */
    isAddPending: function () {
      return FonCartDrawer._clickPending || FonCartDrawer._addsInFlight > 0;
    },

    openCartDrawer: function (pending) {
      if (pending) {
        /* The click. Mark the add in flight — a render landing mid-add must
           not announce an empty cart — but open nothing. The class is only a
           marker for anyone inspecting the DOM; the logic reads the flags. */
        FonCartDrawer._clickPending = true;
        $('body').addClass('fon-cart-pending');
        clearTimeout(FonCartDrawer._clickPendingTimer);
        FonCartDrawer._clickPendingTimer = setTimeout(function () {
          /* No add.js ever went out — the handler bailed after the click.
             Expire the mark or every later open defers behind the fallback. */
          FonCartDrawer._clickPending = false;
          $('body').removeClass('fon-cart-pending');
        }, 10000);
        return;
      }

      /* While an add is in flight, remember that an open was wanted and let
         the render perform it.

         Keying off _awaitingKeys alone is not enough: 18 of the 28 add call
         sites call openCartDrawer() BEFORE updateCartDrawer(), so the keys do
         not exist yet at this point. isAddPending() is true from the click,
         so it covers the whole add either way. */
      if (FonCartDrawer._awaitingKeys || FonCartDrawer.isAddPending()) {
        FonCartDrawer._openWhenRendered = true;
        FonCartDrawer._armOpenFallback();
        return;
      }

      FonCartDrawer._openDrawerNow();
    },

    /* Record the lines an add returned, so the render knows what to wait for. */
    awaitAddedLines: function (addResponse) {
      var keys = FonCartDrawer._addedLines(addResponse)
        .map(function (line) { return line.key; })
        .filter(Boolean);
      if (!keys.length) return;

      FonCartDrawer._awaitingKeys = keys;
      if (FonCartDrawer._openWhenRendered) FonCartDrawer._armOpenFallback();
    },

    /* A click must never go unanswered. If the render fails or never comes,
       open anyway rather than leaving the customer with nothing. */
    _armOpenFallback: function () {
      if (FonCartDrawer._awaitTimer) return;
      FonCartDrawer._awaitTimer = setTimeout(function () {
        FonCartDrawer.flushDeferredOpen(true);
      }, 4000);
    },

    /* Called after every render. Opens the drawer once the added line is
       actually on screen — so the drawer's first frame is its final one. */
    flushDeferredOpen: function (force) {
      var keys = FonCartDrawer._awaitingKeys;
      if (keys) {
        /* `some`, not `every`. A bundle add posts several lines, but the
           render folds a whole _bundle_group_id into its row-1 element, so the
           companion keys never appear in the DOM and requiring all of them
           would stall every bundle add until the fallback fires. */
        var rendered = keys.some(function (key) {
          return $('.fon-cart-line-items [data-line-key="' + key + '"]').length > 0;
        });
        if (!rendered && !force) return;

        /* Clear the keys even when no open was requested — leaving them
           behind made a later header-icon click wait on a line that might
           already have left the cart. */
        FonCartDrawer._awaitingKeys = null;
        clearTimeout(FonCartDrawer._awaitTimer);
        FonCartDrawer._awaitTimer = null;
      }

      if (!FonCartDrawer._openWhenRendered) return;
      FonCartDrawer._openWhenRendered = false;
      FonCartDrawer._openDrawerNow();
    },

    /* Opens the drawer. Only ever reached once there is something real to
       show — either a render has just drawn the added line, or the drawer was
       opened directly (the header cart icon, a cross-sell). */
    _openDrawerNow: function () {
      /* The skeleton may be injected below, so its stylesheet has to exist
         now rather than at render time. */
      FonCartDrawer._installRowAnimation();

      /* A direct open can still arrive before the drawer has ever rendered —
         the markup ships with .fon-cart-line-items empty and nothing fills it
         until updateCartDrawer() runs. A bare panel between a header and a $0
         footer reads as broken, so stand a skeleton in it. An add never gets
         here with an empty panel: it waits for its line to be drawn first. */
      if (!$('.fon-cart-line-items').children().length) {
        $('.fon-cart-line-items').html(FonCartDrawer.skeletonHtml());
      }

      /* Do NOT clear the line items here.

         This used to run in the add-to-cart success callback, so the panel was
         blank for a few milliseconds before the render replaced it. The drawer
         now opens on click instead — meaning this emptied it for the ~1.1s that
         /cart/add.js takes, and the container's `transition: 0.7s` animated the
         collapse and refill. That is the fade-out-then-fade-in.

         Leaving the previous contents in place means the drawer opens showing
         the cart it already has and the new render swaps in underneath, with no
         blank interval at all. updateCartDrawer() replaces the contents wholesale
         on every run, so nothing stale can survive it. */
      $('body').addClass('body-fon-cart-drawer with-cart-items');

      FonCartDrawer.trackEvent('cart_drawer_opened');
      // Offer impressions: check once the drawer contents have rendered,
      // fire each offer type at most once per open.
      setTimeout(function () {
        try {
          if ($('.fon-upsell:visible').length) {
            FonCartDrawer.trackEvent('cart_drawer_offer_view', { offer: 'upsell-90-day' });
          }
          if ($('.fon-cross:visible').length) {
            FonCartDrawer.trackEvent('cart_drawer_offer_view', { offer: 'cross-sell-complete-system' });
          }
        } catch (e) { /* analytics only */ }
      }, 800);

    },

    // Context-aware comprehensive cross-sell. `context` is 'onefit', 'onelife', or
    // null (hidden). Sets the heading, title and CTA to match what the shopper has.
    applyCrossSellContext: function (context, perDay) {
      var CONTEXTS = {
        onefit: {
          heading: '92% Of OneFit Customers Also Take OneLife.',
          title: 'Complete System 90-Day Supply',
          cta: 'Upgrade & Take Your Longevity Seriously'
        },
        onelife: {
          heading: '87% Of OneLife Customers Also Take OneFit.',
          title: 'Complete System 90-Day Supply',
          cta: 'Upgrade & Unlock The Physical Layer'
        },
        duo: {
          heading: 'Share The Protocol With Your Friends & Family.',
          title: 'Complete System Duo Supply',
          cta: 'Upgrade & Keep Each Other On Track'
        }
      };

      var $els = $('.fon-cross, .fon-cross-divider, .fon-cross-heading');
      // No card when nothing is in stock to offer (see the snippet) — hide the rest with it.
      var ctx = context && $('.fon-cross').length ? CONTEXTS[context] : null;

      if (!ctx) {
        $els.hide();
        return;
      }

      $('.fon-cross-heading').text(ctx.heading);
      $('.fon-cross .fon-cross__title').text(ctx.title);
      $('.fon-cross .fon-cross__cta').text(ctx.cta);
      // Context-aware "Add For Only $X/Per Day" — the cost of the product being added.
      if (typeof perDay === 'number' && isFinite(perDay) && perDay > 0) {
        var v = perDay % 1 === 0 ? perDay.toFixed(0) : perDay.toFixed(2);
        $('.fon-cross .fon-cross__sub').html('Add For Only <span class="with-currency-code">' + v + '</span>/Per Day');
      }
      $('.fon-cross').attr('data-context', context);
      // Explicit display values (the card is flex) — it starts hidden in the markup to
      // avoid a flash, and jQuery .show() would wrongly set the flex card to block.
      $('.fon-cross-heading').css('display', 'block');
      $('.fon-cross').css('display', 'flex');
      $('.fon-cross-divider').css('display', 'block');
    },

    /* Advertised discount off the "before" price, by upsell target handle. The
       PDP cards state these (e.g. OneFit's "SAVE 34%"), so the drawer must agree:
         original = total / (1 − pct)   ->  297 / 0.66 = 450, save 153
       Targets absent from this map keep the old 3 × one-time-price basis. */
    BUNDLE_DISCOUNT: {
      'onefit': 0.34
    },

    /* `onefit` is the canonical OneFit handle and `onefit-b` the retired one, but
       upsellTargets / BUNDLE_DISCOUNT are keyed by the canonical 'onefit'. Normalise so a
       line bought from either URL finds its 90-day upsell and discount basis. */
    handleKey: function (handle) {
      return handle === 'onefit-b' ? 'onefit' : handle;
    },

    // Original ("before") price in cents for a 90-day total, per the advertised %.
    // Rounded to a whole dollar — a struck-through "$449.63" reads as a mistake.
    originalFromTotal: function (totalCents, pct) {
      if (!pct || pct <= 0 || pct >= 1) return null;
      return Math.round(totalCents / (1 - pct) / 100) * 100;
    },

    // Builds the "Switch To 90 Days" subscription upsell for a line item.
    // Only renders for try-once products that have a target (onefit-b, onelife-jar).
    // Savings = advertised original − 90-day total, or (3 × try-once price) − total.
    buildLineItemUpsell: function (item) {
      var targets = FonCartDrawer.upsellTargets || {};
      var t = targets[FonCartDrawer.handleKey(item.handle)];
      if (!t) return '';

      // Money helper: cents → display string (drop trailing .00)
      var fmt = function (cents) {
        var v = cents / 100;
        return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
      };
      var cc = function (cents) {
        return '<span class="with-currency-code">' + fmt(cents) + '</span>';
      };

      // Everything scales by the try-once quantity in the cart.
      var qty = item.quantity || 1;
      var pOnce = item.final_price;                        // try-once unit price (cents)
      // Oct 14: priced off the 90-day variant the line maps to (a pouch line quoted the
      // sachet's $99/mo beside a $94/mo pouch plan); the target's default otherwise.
      var mappedT = t.skuMap && item.sku ? t.skuMap[item.sku] : null;
      var tTotal = (mappedT && mappedT.total) || t.total;
      // Prefer the advertised discount (matches the PDP badge); else 3 × one-time.
      var _orig = FonCartDrawer.originalFromTotal(tTotal, FonCartDrawer.BUNDLE_DISCOUNT[FonCartDrawer.handleKey(item.handle)]);
      var save = qty * ((_orig || (3 * pOnce)) - tTotal); // savings, × try-once qty
      var vsPrice = qty * pOnce;                           // one-time spend at this qty
      var perDay = qty * (tTotal === t.total ? t.perDay : Math.floor(tTotal / 90));
      var monthly = qty * (tTotal === t.total ? t.monthly : Math.floor(tTotal / 3));

      // Preserve the try-once flavour: if the target has a skuMap and the line's SKU
      // is in it, swap in that flavour's 90-day variant (reusing the target's own
      // properties template). Otherwise fall back to the default addItems.
      var addItems = t.addItems || [];
      var mapped = t.skuMap && item.sku ? t.skuMap[item.sku] : null;
      if (mapped && addItems[0]) {
        var base = addItems[0];
        var gid = (base.properties && base.properties._BUNDLE ? base.properties._BUNDLE : 'bundle') + '_' + mapped.id;
        var props = Object.assign({}, base.properties, { _bundle_group_id: gid, _offer: gid });
        var mappedItem = { id: mapped.id, quantity: base.quantity, properties: props };
        if (mapped.plan) mappedItem.selling_plan = mapped.plan;
        addItems = [mappedItem];
      }

      // Scale the 90-day add payload by the try-once quantity too.
      var addItemsAttr = JSON.stringify(addItems.map(function (it) {
        return Object.assign({}, it, { quantity: it.quantity * qty });
      }));

      var titleSave = save > 0 ? (', <span class="fon-upsell__title-save">Save ' + cc(save) + '</span>') : '';

      return `
        <div class="fon-upsell-wrap">
          <div class="fon-upsell fon-upsell--animated" data-line-key="${item.key}" data-from-desc="${(item.product_title || '').replace(/"/g, '&quot;')}" data-add-items='${addItemsAttr}'>
            <h3 class="fon-upsell__title">Switch To 90 Days${titleSave}</h3>

            <div class="fon-upsell__perks">
              <img class="fon-upsell__perks-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Pause_SVG.svg?v=1783318043" alt="" width="15" height="15" loading="lazy">
              Pause, adjust flavours, cancel any time
            </div>

            <div class="fon-upsell__price">
              <span class="fon-upsell__price-main">${cc(perDay)}/Day</span>
              <span class="fon-upsell__price-compare">${cc(monthly)}/mo vs. ${cc(vsPrice)}</span>
            </div>

            <button type="button" class="fon-upsell__cta">Subscribe &amp; Save</button>

            <hr class="fon-upsell__divider">

            <div class="fon-upsell__supply-head">
              <span class="fon-upsell__supply-title">A 90-Day Supply Covers You For <strong>${t.weeks} Weeks</strong></span>
              <img class="fon-upsell__cal-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/mdi_calendar.svg?v=1783318090" alt="" width="16" height="16" loading="lazy">
            </div>

            <div class="fon-upsell__bar" role="progressbar" aria-valuenow="97" aria-valuemin="0" aria-valuemax="100" aria-label="Supply progress">
              <div class="fon-upsell__bar-fill"></div>
            </div>

            <div class="fon-upsell__weeks">
              ${FonCartDrawer.weekMarkers(t.weeks)}
            </div>
          </div>
        </div>
      `;
    },

    // Builds a "Switch To 90 Days" upsell for a whole bundle group (e.g. the
    // comprehensive one-month → comprehensive 90-day). Unlike buildLineItemUpsell
    // (single line, keyed by handle), this targets every line sharing bundleGroupId
    // and is keyed by an explicit target key. bundleOneTimeDollars is the current
    // one-time bundle total (dollars) used as the "vs" / savings basis.
    buildBundle90Upsell: function (key, bundleGroupId, bundleOneTimeDollars, ofSku) {
      var targets = FonCartDrawer.upsellTargets || {};
      var t = targets[key];
      if (!t) return '';

      var fmt = function (cents) {
        var v = cents / 100;
        return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
      };
      var cc = function (cents) {
        return '<span class="with-currency-code">' + fmt(cents) + '</span>';
      };

      var pOnce = Math.round((Number(bundleOneTimeDollars) || 0) * 100); // 30-day one-time total (cents)
      // Prefer the advertised discount (matches the PDP badge); else 3 × 30-day one-time.
      var _orig = FonCartDrawer.originalFromTotal(t.total, FonCartDrawer.BUNDLE_DISCOUNT[key]);
      var save = (_orig || (3 * pOnce)) - t.total;
      var vsPrice = pOnce;
      var perDay = t.perDay;
      var monthly = t.monthly;

      // Preserve the one-month flavour: map the line's OneFit SKU to its 90-day
      // variant. Build the OneFit + OneLife 90-day payload from that; fall back to
      // the target's default addItems if the SKU isn't in the map.
      var addItems = t.addItems || [];
      var of90 = t.skuMap && ofSku ? t.skuMap[ofSku] : null;
      if (of90 && t.onelife) {
        var groupId = 'comprehensive_90d_' + of90.id;
        var mkProps = function (row, mult) {
          var p = {
            _BUNDLE: 'comprehensive_90d',
            _bundle_group_id: groupId,
            _bundle_group_product: true,
            _bundle_group_product_row: row,
            _bundle_group_product_multiplier: mult,
            _offer: groupId,
            _offer_product_type: 'primary',
            _order_from: 'comprehensive-challenger',
            _order_from_cart_upsell: true
          };
          return p;
        };
        var ofItem = { id: of90.id, quantity: 5, properties: mkProps(1, 5) };
        if (of90.plan) ofItem.selling_plan = of90.plan;
        var olItem = { id: t.onelife.id, quantity: t.onelife.quantity || 3, properties: mkProps(2, 3) };
        if (t.onelife.plan) olItem.selling_plan = t.onelife.plan;
        addItems = [ofItem, olItem];
      }
      var addItemsAttr = JSON.stringify(addItems);
      var titleSave = save > 0 ? (', <span class="fon-upsell__title-save">Save ' + cc(save) + '</span>') : '';

      return `
        <div class="fon-upsell-wrap">
          <div class="fon-upsell fon-upsell--animated" data-bundle-group-id="${bundleGroupId}" data-from-desc="one-month system bundle" data-add-items='${addItemsAttr}'>
            <h3 class="fon-upsell__title">Switch To 90 Days${titleSave}</h3>

            <div class="fon-upsell__perks">
              <img class="fon-upsell__perks-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Pause_SVG.svg?v=1783318043" alt="" width="15" height="15" loading="lazy">
              Pause, adjust flavours, cancel any time
            </div>

            <div class="fon-upsell__price">
              <span class="fon-upsell__price-main">${cc(perDay)}/Day</span>
              <span class="fon-upsell__price-compare">${cc(monthly)}/mo vs. ${cc(vsPrice)}</span>
            </div>

            <button type="button" class="fon-upsell__cta">Subscribe &amp; Save</button>

            <hr class="fon-upsell__divider">

            <div class="fon-upsell__supply-head">
              <span class="fon-upsell__supply-title">A 90-Day Supply Covers You For <strong>${t.weeks} Weeks</strong></span>
              <img class="fon-upsell__cal-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/mdi_calendar.svg?v=1783318090" alt="" width="16" height="16" loading="lazy">
            </div>

            <div class="fon-upsell__bar" role="progressbar" aria-valuenow="97" aria-valuemin="0" aria-valuemax="100" aria-label="Supply progress">
              <div class="fon-upsell__bar-fill"></div>
            </div>

            <div class="fon-upsell__weeks">
              ${FonCartDrawer.weekMarkers(t.weeks)}
            </div>
          </div>
        </div>
      `;
    },

    /* ======================================================================
       CART CACHE
    
       One add-to-cart used to fetch /cart.js four times over — from
       clearOrphanedBundleItems, awaitClearFreeItems, updateSellingPlanQuantity
       and updateCartDrawer — each waiting on the last, every one returning the
       same unchanged cart. All fifteen readers now share one promise.
    
       THE CACHE IS ONLY AS CORRECT AS ITS INVALIDATION. The promise is kept
       after it resolves, not dropped on settle: the readers run one after
       another rather than concurrently, so sharing only in-flight promises
       would find nothing to reuse. Everything therefore depends on
       invalidateCart() firing on every mutation, which _installInvalidation()
       guarantees for jQuery calls; the drawer's own fetch() mutations call it
       directly.
       ====================================================================== */

    _cartPromise: null,

    /* The cart as we last knew it — server-confirmed, or computed by
       primeFromAdd and since confirmed by the reconcile. Kept across
       invalidation, and used as the base an optimistic add merges onto. */
    _lastCart: null,

    /* The cart the drawer last drew, for the optimistic reconcile to compare. */
    _drawnCart: null,

    /* Mutation counter, and the value getCart() stamped its promise with.
       Together they answer "was this cart read before or after the mutation
       that just finished?" — see _installInvalidation for why that matters. */
    _mutationSeq: 0,
    _cartSeq: -1,

    _invalidationInstalled: false,

    /* The cart, shared. Pass force:true to bypass the cache deliberately. */
    getCart: function (force) {
      FonCartDrawer._installInvalidation();

      if (force || !FonCartDrawer._cartPromise) {
        FonCartDrawer._cartSeq = FonCartDrawer._mutationSeq;
        FonCartDrawer._cartPromise = $.getJSON('/cart.js');

        /* Never cache a failure, or every later read replays it. */
        FonCartDrawer._cartPromise.fail(function () {
          FonCartDrawer._cartPromise = null;
        });

        /* The last cart the server confirmed. An optimistic render starts
           from this snapshot rather than from nothing — see primeFromAdd(). */
        FonCartDrawer._cartPromise.done(function (cart) {
          FonCartDrawer._lastCart = cart;
        });
      }

      return FonCartDrawer._cartPromise;
    },

    invalidateCart: function () {
      FonCartDrawer._cartPromise = null;
    },

    /* ----------------------------------------------------------------------
       OPTIMISTIC ADD

       /cart/add.js already returns the lines it just added; /cart.js afterwards
       returns those same lines plus the ones we already knew about. Waiting for
       it costs a second round trip to learn almost nothing.

       So we merge the add onto the last confirmed cart and prime the cache with
       the result. Every reader downstream — the three fixup passes and the
       render itself — then sees a complete cart and draws immediately. Nothing
       in the render path knows or cares that this cart came from arithmetic.

       Totals are ours only until the server's arrive: updateCartDrawer()
       reconciles against a real /cart.js and redraws if the two disagree.
       ---------------------------------------------------------------------- */

    /* add.js answers with a bare line for one item and {items:[…]} for many. */
    _addedLines: function (addResponse) {
      if (!addResponse) return [];
      if (addResponse.items) return addResponse.items;
      return addResponse.key ? [addResponse] : [];
    },

    /* Returns true if the cache now holds a usable cart, false to fall back. */
    primeFromAdd: function (addResponse) {
      var added = FonCartDrawer._addedLines(addResponse);
      var base  = FonCartDrawer._lastCart;
      if (!added.length || !base) return false;

      /* Discount codes reprice the whole cart server-side; we can't do that
         arithmetic here, so don't pretend to. */
      if ((base.cart_level_discount_applications || []).length) return false;

      var items = (base.items || []).slice();
      added.forEach(function (line) {
        var at = -1;
        items.forEach(function (item, i) { if (item.key === line.key) at = i; });
        /* add.js reports the line's new total quantity, not the delta. New
           lines go in FRONT — /cart.js lists newest first, and matching that
           keeps the row from jumping position when a later render uses the
           server's order. */
        if (at > -1) items[at] = line; else items.unshift(line);
      });

      var cart = $.extend({}, base);
      cart.items = items;
      cart.item_count = items.reduce(function (n, i) { return n + (i.quantity || 0); }, 0);
      cart.total_price = items.reduce(function (n, i) {
        return n + (i.final_line_price != null ? i.final_line_price : i.line_price || 0);
      }, 0);
      cart.items_subtotal_price = cart.total_price;

      FonCartDrawer.primeCart(cart);
      return true;
    },

    /* Seat a cart in the cache as if /cart.js had just returned it. Stamped
       with the current mutation seq so ajaxComplete doesn't discard it. */
    primeCart: function (cart) {
      FonCartDrawer._cartSeq = FonCartDrawer._mutationSeq;
      FonCartDrawer._cartPromise = $.Deferred().resolve(cart).promise();

      /* This is the cart now, so it is also what the next add merges onto.
         Without this, _lastCart stayed at whatever the page loaded with and a
         second add merged onto that — dropping the first add from the drawer. */
      FonCartDrawer._lastCart = cart;
    },

    /* True when the server's cart says something the drawn one didn't. */
    _cartDiffers: function (a, b) {
      if (!a || !b) return true;
      if (a.item_count !== b.item_count) return true;
      if (a.total_price !== b.total_price) return true;
      if ((a.items || []).length !== (b.items || []).length) return true;
      /* Order-insensitive. The merged cart and the server's can list the
         same lines in a different order, and a repaint over a reordering the
         shopper can't see is exactly the blink this path exists to avoid. */
      var qtyByKey = {};
      (b.items || []).forEach(function (item) { qtyByKey[item.key] = item.quantity; });
      return (a.items || []).some(function (item) {
        return qtyByKey[item.key] !== item.quantity;
      });
    },

    /* Watches every cart mutation on the page and drops the cache around it.
       Hooked at the ajax layer rather than at the ~20 individual call sites, so
       a call site added later is covered without anyone remembering to.

       The sequence numbers are what make this usable rather than merely safe.
       jQuery fires success BEFORE ajaxComplete, and callers read the cart inside
       success — so invalidating on both edges meant a read would start, cache,
       and then have that cache thrown away by ajaxComplete, forcing the next
       reader to fetch the identical cart again. Comparing the two counters drops
       only a cache that predates the mutation; one created inside success
       carries the current seq and survives. */
    _installInvalidation: function () {
      if (FonCartDrawer._invalidationInstalled) return;
      FonCartDrawer._invalidationInstalled = true;

      var isCartMutation = function (settings) {
        return /\/cart\/(add|change|update|clear)\.js/.test((settings && settings.url) || '');
      };

      /* The back button can restore this page from the browser's cache with
         all of our state intact — including a cart promise from before the
         shopper checked out or edited the cart on another page. Nothing else
         fires in that case, so listen for the restore itself. */
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        FonCartDrawer.invalidateCart();
        FonCartDrawer.getCart();
      });

      var isCartAdd = function (url) {
        return /\/cart\/add\.js/.test(url || '');
      };

      $(document).ajaxSend(function (e, xhr, settings) {
        if (!isCartMutation(settings)) return;
        FonCartDrawer._mutationSeq++;
        FonCartDrawer.invalidateCart();
        if (isCartAdd(settings && settings.url)) {
          FonCartDrawer._addsInFlight++;
          /* The add is on the wire; the click-mark has done its job. */
          FonCartDrawer._clickPending = false;
          clearTimeout(FonCartDrawer._clickPendingTimer);
        }
      });

      /* jQuery's hooks only see jQuery. Anything using native fetch — another
         script, an app, a future rewrite of this file — would mutate the cart
         and leave the cache holding a pre-mutation snapshot. Verified: clearing
         the cart with fetch() left updateCartDrawer rendering the old contents.
         The wrapper inspects the URL and passes everything else straight
         through. */
      if (window.fetch && !window.fetch.__fonCartHooked) {
        var nativeFetch = window.fetch;
        var hooked = function (input, init) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (isCartMutation({ url: url })) {
            FonCartDrawer._mutationSeq++;
            FonCartDrawer.invalidateCart();
          }
          if (isCartMutation({ url: url }) && isCartAdd(url)) {
            FonCartDrawer._addsInFlight++;
            FonCartDrawer._clickPending = false;
            clearTimeout(FonCartDrawer._clickPendingTimer);
          }
          var settle = function () {
            if (!isCartMutation({ url: url })) return;
            if (FonCartDrawer._cartSeq < FonCartDrawer._mutationSeq) FonCartDrawer.invalidateCart();
            if (isCartAdd(url)) {
              FonCartDrawer._addsInFlight = Math.max(0, FonCartDrawer._addsInFlight - 1);
              if (FonCartDrawer._addsInFlight === 0) FonCartDrawer.clearPending();
            }
          };
          return nativeFetch.apply(this, arguments).then(
            function (res) { settle(); return res; },
            function (err) { settle(); throw err; }
          );
        };
        hooked.__fonCartHooked = true;
        window.fetch = hooked;
      }

      $(document).ajaxComplete(function (e, xhr, settings) {
        if (!isCartMutation(settings)) return;
        if (FonCartDrawer._cartSeq < FonCartDrawer._mutationSeq) FonCartDrawer.invalidateCart();

        /* Only an ADD finishing can end the pending window — the housekeeping
           update.js/change.js calls used to end it here too, stripping the
           mark off a second add that was still in flight. And only the LAST
           add: the counter keeps the window open through overlapping adds. */
        if (isCartAdd(settings && settings.url)) {
          FonCartDrawer._addsInFlight = Math.max(0, FonCartDrawer._addsInFlight - 1);
          if (FonCartDrawer._addsInFlight === 0) FonCartDrawer.clearPending();
        }
      });
    },

    /* ======================================================================
       DRAWER RENDER TIMING
       ====================================================================== */

    _rowAnimationInstalled: false,

    /* Animates the ROWS in, never the panel.

       Hiding and restoring the panel is what made the drawer blink — at jQuery's
       800ms default and just as badly at 200ms, because either way there is a
       frame where the drawer looks empty. Animating the rows keeps the container
       solid while new content eases in.

       This also switches off the `transition: 0.7s` that the four
       fon-critical-product-*.liquid snippets set on .fon-cart-line-items. That
       shorthand covers ALL properties, so every content change — height included
       — eased over 700ms. Overridden here rather than in those snippets so the
       drawer owns its timing wherever it renders.

       Opacity only: these rows re-render on every cart change, and a transform
       would nudge the layout each time. */
    _installRowAnimation: function () {
      if (FonCartDrawer._rowAnimationInstalled) return;
      FonCartDrawer._rowAnimationInstalled = true;

      var st = document.createElement('style');
      st.id = 'fon-cart-row-anim';
      st.textContent =
        '.fon-cart-line-items{transition:none!important;}' +
        '@keyframes fonCartRowIn{from{opacity:0}to{opacity:1}}' +
        '.fon-cart-line-items > *{animation:fonCartRowIn 90ms linear both;}' +
        '@media (prefers-reduced-motion:reduce){.fon-cart-line-items > *{animation:none;}}' +

        /* Skeleton. Same box as a real line item so nothing shifts on swap. */
        '.fon-cart-skeleton{display:flex;gap:15px;align-items:flex-start;' +
          'background:#fffffc;border:1px solid rgba(41,41,35,.1);border-radius:4px;' +
          'padding:10px;min-height:159px;box-sizing:border-box;}' +
        '.fon-cart-skeleton__img{flex:0 0 80px;width:80px;height:80px;border-radius:2px;}' +
        '.fon-cart-skeleton__lines{flex:1 1 auto;display:flex;flex-direction:column;gap:10px;padding-top:4px;}' +
        '.fon-cart-skeleton__bar{display:block;height:12px;border-radius:3px;}' +
        '.fon-cart-skeleton__img,.fon-cart-skeleton__bar{' +
          'background:linear-gradient(90deg,#ececec 25%,#f6f6f6 37%,#ececec 63%);' +
          'background-size:400% 100%;animation:fonCartShimmer 1.2s ease-in-out infinite;}' +
        '@keyframes fonCartShimmer{0%{background-position:100% 50%}100%{background-position:0 50%}}' +
        '@media (prefers-reduced-motion:reduce){' +
          '.fon-cart-skeleton__img,.fon-cart-skeleton__bar{animation:none;background:#ececec;}}';
      document.head.appendChild(st);
    },

    /* Placeholder row shown while an add is in flight. Mirrors the real
       .fon-line-item-wrapper geometry — 4px radius, 1px border, 10px padding,
       80x80 image block — so the swap to the real row does not jump. */
    skeletonHtml: function () {
      return (
        '<div class="fon-cart-skeleton" aria-hidden="true">' +
          '<div class="fon-cart-skeleton__img"></div>' +
          '<div class="fon-cart-skeleton__lines">' +
            '<span class="fon-cart-skeleton__bar" style="width:45%"></span>' +
            '<span class="fon-cart-skeleton__bar" style="width:80%"></span>' +
            '<span class="fon-cart-skeleton__bar" style="width:60%"></span>' +
          '</div>' +
        '</div>'
      );
    },

    /* Ends the pre-emptive-open window opened by openCartDrawer(true). While it
       is open the empty-cart message is suppressed, because the cart is briefly
       and legitimately empty while an add is in flight. */
    clearPending: function () {
      /* Deliberately does NOT clear _awaitingKeys: this runs on the add's
         ajaxComplete, which fires well before the render it is waiting for.
         A failed add never sets those keys, so there is nothing to strand. */
      FonCartDrawer._clickPending = false;
      clearTimeout(FonCartDrawer._clickPendingTimer);
      $('body').removeClass('fon-cart-pending');
      /* A successful add re-renders the panel, which replaces the skeleton. A
         FAILED one never renders, so remove it here or it sits there forever. */
      $('.fon-cart-skeleton').remove();
    },

    /* `_order_from` is built as 'conquesting_' + page.handle (fon-conquesting.js),
       and every conquesting page lives at /pages/<handle> — the mapping is an
       identity. Derive it rather than keeping a hard-coded switch that goes stale
       the moment a new vs- page ships. Returns null for non-conquesting orders. */

    conquestingUrl: function (orderFrom) {
      var prefix = 'conquesting_';
      var of = String(orderFrom || '');
      if (of.indexOf(prefix) !== 0) return null;
      var handle = of.slice(prefix.length);
      return handle ? ('/pages/' + handle) : null;
    },

    /* Where a line's "back to where you bought it" link should point.

       Prefers _order_from_url, which the page writes at add-to-cart time, so a
       campaign page that moves — or gets its own /pages/ handle instead of
       riding ?view= — needs no change here. Falls back to the conquesting
       derivation for every line added before that property existed.

       The value is a cart line property, so it is treated as untrusted: only a
       same-site path is accepted. A protocol-relative "//evil.com" or an
       absolute URL is rejected, which is what stops this becoming an open
       redirect in the drawer's markup. */
    orderFromUrl: function (item) {
      var raw = item && item.properties && item.properties._order_from_url;
      var url = String(raw || '');
      if (url.charAt(0) === '/' && url.charAt(1) !== '/' && url.indexOf(':') === -1) return url;
      return FonCartDrawer.conquestingUrl(item && item.properties && item.properties._order_from);
    },

    // Week markers for the upsell supply bar, with the calendar date for each week
    // computed from today (Week N ≈ today + (N-1) weeks).
    // Full variant flavour -> the short name. Call AFTER any colour lookup, which
    // is keyed by the full name.
    shortFlavour: function (name) {
      var map = FonCartDrawer.onefitFlavourShortNames || {};
      var key = String(name || '')
        .replace(/OneFit®?|OneLife™?/gi, '')   // brand prefix off the variant title
        .replace(/\s+/g, ' ').trim().toLowerCase();
      return map[key] || name;
    },

    weekMarkers: function (totalWeeks) {
      var fmtDate = function (weeksFromNow) {
        var d = new Date();
        d.setDate(d.getDate() + (weeksFromNow * 7));
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      };
      var mk = function (label, weeksFromNow) {
        return '<span>' + label +
          ' <small class="fon-upsell__week-date">(' + fmtDate(weeksFromNow) + ')</small></span>';
      };
      // Each marker lands on the END of that week: Week 1 = +7 days.
      var last = parseInt(totalWeeks, 10) || 12;
      return mk('Week 1', 1) + mk('Week 4', 4) + mk('Week ' + last, last);
    },

    // Start each upsell supply bar's continuous fill loop once the drawer has
    // finished rendering/fading in, so the 5% start state is painted first.
    // The 8s loop itself lives in CSS (@keyframes fon-upsell-fill).
    animateUpsellBars: function () {
      var bars = document.querySelectorAll('.fon-upsell__bar-fill:not([data-animated])');
      if (!bars.length) return;
      bars.forEach(function (el) { el.setAttribute('data-animated', '1'); });
      void document.body.offsetWidth;   // flush the 5% layout before the loop starts
      requestAnimationFrame(function () {
        bars.forEach(function (el) { el.classList.add('is-visible'); });
      });
    },

    computeCartItems: function () {

    },

    updateSellingPlanQuantity: function() {
      return new Promise((resolve, reject) => {

  
        FonCartDrawer.getCart().then(function(cart) {
          var updates = {};

          cart.items.forEach(function(item) {

            console.log('item',item);
            if (
              item.product_title == "Special Price Products" &&
              item.quantity >= 3
            ) {
              var newQty = Math.floor(item.quantity / 3);
              updates[item.key] = newQty;
            }
          });

          if (Object.keys(updates).length > 0) {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { updates: updates },
              dataType: 'json',
              success: function(updatedCart) {
                console.log('Updated quantities for 12-month Supply items.');
                resolve(); // ✅ Proceed only after update is done
              },
              error: function(err) {
                console.error('Bulk update error:', err);
                reject(err); // ❌ Catch error if needed
              }
            });
          } else {
            console.log('No 12-month Supply items with quantity > 3 found.');
            resolve(); // ✅ Nothing to update, still resolve
          }
        });
      });
    },


    awaitClearFreeItems: function(variantIds = [], label = 'Item') {
      return new Promise((resolve, reject) => {

        FonCartDrawer.getCart().then(function(cart) {
          // 1️⃣ Items to remove by variant_id
          let itemsToRemoveByVariant = cart.items.filter(i => variantIds.includes(i.variant_id));

          // 2️⃣ Items to remove by _cart_hidden: yes
          let itemsToRemoveHidden = cart.items.filter(i => 
            i.properties && i.properties._cart_hidden &&
            String(i.properties._cart_hidden).toLowerCase() === 'yes'
          );

          // Combine all items to remove (avoid duplicates)
          let allItemsToRemove = [...new Set([...itemsToRemoveByVariant, ...itemsToRemoveHidden])];

          if (allItemsToRemove.length > 0) {
            let updates = {};
            allItemsToRemove.forEach(item => {
              updates[item.key] = 0; // Remove by line item key
            });

            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { updates: updates },
              dataType: 'json',
              success: function(updatedCart) {
                console.log(label + '(s) removed directly:', allItemsToRemove.map(i => i.key));

                /* Do NOT open the drawer here. This runs mid-add as part of the
                   housekeeping chain; opening is the deferred-open machinery's
                   decision alone (flushDeferredOpen), made after the render. */
                resolve(); // Resolve promise after everything is done
              },
              error: function(err) {
                console.error('Error removing ' + label + '(s):', err);
                reject(err);
              }
            });
          } else {
            console.log(label + '(s) not in the cart — skipping removal.');
            resolve();
          }
        });

      });
    },


    // awaitClearFreeItems: function(variantIds = [], label = 'Item') {
    //   return new Promise((resolve, reject) => {




    //     FonCartDrawer.getCart().then(function(cart) {

    //     let itemsToRemove = cart.items.filter(i => variantIds.includes(i.variant_id));
        
    //       if (itemsToRemove.length > 0) {
    //         // Build updates: set quantity to 0 for each matching item
    //         let updates = {};
    //         itemsToRemove.forEach(item => {
    //           updates[item.key] = 0;
    //         });

    //         $.ajax({
    //           type: 'POST',
    //           url: '/cart/update.js',
    //           data: {
    //             // discount: discountCode,
    //             updates: updates
    //           },
    //           dataType: 'json',
    //           success: function(updatedCart) {
    //             console.log(label + '(s) removed directly:', variantIds);
    //             resolve(); // ✅ Proceed only after update is done
    //           },
    //           error: function(err) {
    //             console.error('Error removing ' + label + '(s):', err);
    //             reject(err); // ❌ Catch error if needed
    //           }
    //         });
    //       } else {
    //         console.log(label + '(s) not in the cart — skipping removal.');
    //         resolve(); // ✅ Nothing to update, still resolve
    //       }
    //     });
      
    //   });
    // },
    // Removes invalid/orphaned bundle items — a bundle group that is missing its
    // row-1 (primary) line (e.g. the OneFit half of a comprehensive bundle failed to
    // add). Rather than show a half-bundle, drop the leftover group items from the cart.
    clearOrphanedBundleItems: function () {
      return new Promise(function (resolve, reject) {
        FonCartDrawer.getCart().then(function (cart) {
          var hasRow1 = {};
          cart.items.forEach(function (i) {
            if (i.properties && i.properties._bundle_group_id && i.properties._bundle_group_product_row == 1) {
              hasRow1[i.properties._bundle_group_id] = true;
            }
          });

          var updates = {};
          cart.items.forEach(function (i) {
            if (i.properties && i.properties._bundle_group_id && i.properties._bundle_group_product &&
                !hasRow1[i.properties._bundle_group_id]) {
              updates[i.key] = 0;
            }
          });

          if (Object.keys(updates).length === 0) { resolve(); return; }

          console.log('Clearing orphaned bundle items:', Object.keys(updates));
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates },
            dataType: 'json',
            success: function () { resolve(); },
            error: function (err) { console.error('Failed to clear orphaned bundle items:', err); resolve(); }
          });
        });
      });
    },

    // updateCartDrawer: function () {
    /* Pass the /cart/add.js response to draw the new lines without waiting for
       a /cart.js of our own; the server's cart is reconciled in afterwards.
       Called with nothing, this behaves exactly as it always has. */
    updateCartDrawer: async function (addResponse) {

     var optimistic = addResponse ? FonCartDrawer.primeFromAdd(addResponse) : false;

     /* Runs before the caller's openCartDrawer() on the next line, so that
        call sees the keys and holds off. */
     if (addResponse) FonCartDrawer.awaitAddedLines(addResponse);

     var itemsToRemoveJan26 = [53301741289656, 51843757670584,51793029103800,52887363551416,53301741289656,52304276357304,52304251027640,52219844985016,53491544391864].concat(FonCartDrawer.GIFT_EXTRA_IDS);

     // ONeLife Bottles 52887363551416,53301741289656

     /* Housekeeping is best-effort; the render is not. These three passes fix
        up quantities and remove stray gift lines, and each can POST — a POST
        that fails (seen live: a 422 when a line key had already gone stale)
        used to throw out of this function before the render ran, leaving the
        drawer open on a skeleton forever. Whatever they couldn't clean up, the
        drawer must still draw. */
     try {
       await FonCartDrawer.updateSellingPlanQuantity();
       await FonCartDrawer.awaitClearFreeItems(itemsToRemoveJan26, 'Free Gift');
       // Drop any invalid bundles (group missing its row-1 primary line) before rendering
       await FonCartDrawer.clearOrphanedBundleItems();
     } catch (err) {
       console.error('Cart housekeeping failed; rendering anyway:', err);
     }

      $('.fon-line-item-free-bottle-row').remove();
      $('.fon-line-item-frother-bottle-row').remove();
      
      $('body').addClass('fon-cart-drawer-updating');

      /* The cart we drew was computed, not fetched. Fetch the real one and
         redraw only if it disagrees — an identical cart must not repaint, or
         the rows animate a second time and the drawer appears to blink. */
      if (optimistic) {
        /* Deliberately not getCart(true): that would swap the primed cart out
           of the cache before the render below ever reads it, and we would be
           waiting on the network again — the exact round trip being skipped.
           This fetch stays outside the cache until it answers, then seats the
           server's cart as the truth for everyone after us. */
        var seqAtFetch = FonCartDrawer._mutationSeq;

        $.getJSON('/cart.js').done(function (server) {
          /* Only seat this if nothing changed the cart while it was in flight.

             getCart() can stamp _cartSeq before its fetch because it is reading
             a cart that already exists. This one cannot: if a mutation starts
             mid-flight, the response predates it, and seating it would stamp
             _cartSeq = _mutationSeq and make ajaxComplete's
             `_cartSeq < _mutationSeq` guard pass — telling the cache a
             pre-mutation cart is current. The mutation's own render would then
             draw the old quantity and the change would vanish from the UI.

             Dropping it is safe: the mutation invalidated the cache on its way
             out, so the next read refetches. */
          if (FonCartDrawer._mutationSeq !== seqAtFetch) return;

          FonCartDrawer.primeCart(server);
          if (FonCartDrawer._cartDiffers(server, FonCartDrawer._drawnCart)) {
            FonCartDrawer.updateCartDrawer();
          }
        });
      }

      FonCartDrawer.getCart().then(function (cart) {
        FonCartDrawer._drawnCart = cart;

          const applicableDiscounts = cart.discount_codes.filter(d => d.applicable);

          if (applicableDiscounts.length > 0) {
            const code = applicableDiscounts[0].code;
            console.log('Discount code applied:', code);
            $('.fon-cart-sub-total.fon-cart-sub-total-discount').css('display','flex');
            $('.fon-cart-sub-total.fon-cart-sub-total-discount .fon-checkout-discount').html(code);
          } else {
            console.log('No discount code applied.');
            $('.fon-cart-sub-total.fon-cart-sub-total-discount').hide();
          }

          // Context-aware cross-sell:
          //   comprehensive_90d present (>=1)  -> 'duo'     (has the complete system)
          //   OneFit SKU only (no OneLife)     -> 'onefit'  (complete with OneLife)
          //   OneLife SKU only (no OneFit)     -> 'onelife' (complete with OneFit)
          //   otherwise                        -> hidden
          // OF-* / OL-* SKU detection is robust across all OneFit/OneLife forms.
          var hasOF = cart.items.some(function (i) { return i.sku && i.sku.indexOf('OF-') === 0; });
          var hasOL = cart.items.some(function (i) { return i.sku && i.sku.indexOf('OL-') === 0; });

          // Count complete systems: each comprehensive_90d bundle's row-1 line
          // quantity ÷ its multiplier (=1 system). Sums across separate groups / qty.
          var comprehensiveCount = 0;
          cart.items.forEach(function (i) {
            if (i.properties && i.properties._BUNDLE === 'comprehensive_90d'
                && i.properties._bundle_group_product_row == 1) {
              var mult = parseInt(i.properties._bundle_group_product_multiplier) || 5;
              comprehensiveCount += (i.quantity / mult);
            }
          });

          // Only offer OneFit/OneLife cross-sell when the cart holds the 90-DAY bundle
          // (not a one-time / other purchase).
          var _hasOF90 = cart.items.some(function (i) { return i.properties && i.properties._BUNDLE === 'onefit_90d'; });
          var _hasOL90 = cart.items.some(function (i) { return i.properties && i.properties._BUNDLE === 'onelife_90d'; });

          var crossContext = null;
          if (comprehensiveCount >= 1) {
            // DUO CARD OFF (2026-10-01, on request): "Share The Protocol With
            // Your Friends & Family." is pulled for now, and it is the whole
            // card's heading, so the card goes with it rather than showing
            // headless. One complete system now offers nothing; two still
            // hide it, as before. To restore: put back the line below.
            //   if (comprehensiveCount < 2) { crossContext = 'duo'; }
          } else if (hasOF && !hasOL && _hasOF90) {
            crossContext = 'onefit';
          } else if (hasOL && !hasOF && _hasOL90) {
            crossContext = 'onelife';
          }

          // "Add For Only $X/Per Day" from the 90-day totals:
          //   onefit -> (comprehensive − onefit)  / 90
          //   onelife-> (comprehensive − onelife) / 90
          //   duo    -> comprehensive / 90 (full)
          var _T = FonCartDrawer.upsellTargets || {};
          var _compT = (_T['comprehensive-1m'] || {}).total || 0;   // cents
          var _ofT   = (_T['onefit']         || {}).total || 0;
          var _olT   = (_T['onelife-jar']      || {}).total || 0;
          var _addCents = _compT;                                   // default / duo = full
          if (crossContext === 'onefit') { _addCents = _compT - _ofT; }
          else if (crossContext === 'onelife') { _addCents = _compT - _olT; }
          var _addPerDay = _addCents ? (_addCents / 90) / 100 : null;

          FonCartDrawer.applyCrossSellContext(crossContext, _addPerDay);


        let html = '';


        




        var totalSubscriptionCount = 0;
        var totalBottle = 0;
        var totalFrother = 0;

        var totalWSWelcomeKit = 0;
        var totalWSBottle = 0;
        var totalWSFrother = 0;


        var totalOLBottle = 0;
        var totalOLFrother = 0;

        // The V4.7 Subscribe & Save gifts (GIFT_RULES.onefit_30d.bySku)
        var totalPremiumFrother = 0;
        var totalCap = 0;


        
        console.log('cart.js',cart);

        

        var item_count = cart.item_count;
        if (item_count === 0){
          $('p.fon-total-items').html('');
        }else{
          $('p.fon-total-items').html(`(${item_count} Items)`);
        }

        // "Your Cart (N)" — same count as the nav badge. Subtotal shows no count.
        var lineItemCount = FonCartDrawer.countCartLineItems(cart);
        $('.fon-subtotal-count').text('');
        $('.fon-heading-count').text(lineItemCount > 0 ? ('(' + lineItemCount + ')') : '');

        // Keep the nav badge in step with this render — no extra /cart.js fetch.
        FonCartDrawer.renderCartCount(cart);


        if (cart.items.length > 0) {


          var total = cart.total_price / 100;

          var formattedTotal = (total % 1 === 0)
          ? total.toFixed(0)
          : total.toFixed(2);

          $('.fon-checkout-total').html(
            '<span class="with-currency-code">' + formattedTotal + '</span>'
          );

          $('.fon-checkout-total-2').html(
            ' - <span class="with-currency-code">' + formattedTotal + '</span>'
          );

          // Make sure "empty" class is removed
          $('.fon-checkout-total').removeClass('empty');

        } else {
          // Handle empty cart
          $('.fon-checkout-total, .fon-checkout-total-2')
            .addClass('empty')
            .html('<span class="with-currency-code">0</span>');
        }


      // // Check if cart has items
      // if (cart.items.length > 0) {

      //   // Sum up all line item totals in the cart
      //   var totalCents = 0;
      //   cart.items.forEach(function(item) {
      //     totalCents += item.final_line_price; // Still in cents
      //   });

      //   // Convert from cents to dollars
      //   var total = totalCents / 100;

        

      //   // Format the price — remove .00 if not needed
      //   var formattedTotal = (total % 1 === 0)
      //     ? total.toFixed(0)
      //     : total.toFixed(2);

      //   // Update the checkout total element
      //   $('.fon-checkout-total').html(
      //     '<span class="with-currency-code">' + formattedTotal + '</span>'
      //   );

      //   // Make sure "empty" class is removed
      //   $('.fon-checkout-total').removeClass('empty');

      // } else {
      //   // Handle empty cart
      //   $('.fon-checkout-total')
      //     .addClass('empty')
      //     .html('<span class="with-currency-code">0</span>');
      // }

        var bundlesActive = [];

        var totalBundleBottle = 0;
        var totalBundleFrother = 0;
        $('.fon-cart-drawer').attr('data-bundle-bottle',totalBundleBottle);
        $('.fon-cart-drawer').attr('data-bundle-frother',totalBundleFrother);
        

        cart.items.forEach(function (item) {
          let originalPrice = item.original_line_price / 100;
          let finalPrice = item.final_line_price / 100;
          let finalPriceWS = item.final_line_price / 100;
          let hasDiscount = originalPrice > finalPrice;
          let discountAmount = (originalPrice - finalPrice).toFixed(2);
          let discountPercent = Math.round((1 - finalPrice / originalPrice) * 100);

          var paymentType = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : 'One-time Purchase';

          let productTitle = item.product_title;
          var hasBundle = false;

          if (item.properties && item.properties._BUNDLE) {
            hasBundle = true;

          }

          

          if (item.properties && item.properties._BUNDLE && item.properties._bundle_group_id  && item.properties._bundle_group_product ) {

              var _bundle_group_id = item.properties._bundle_group_id;

              if (item.properties._bundle_group_product && !bundlesActive.includes(_bundle_group_id) && item.properties._bundle_group_product_row == 1) {
                

                


                var bundleSubscriptionInfo = '';
                var bundleSalePrice = parseFloat(item.properties._bundle_group_sale_price) * item.quantity;
                var bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price) * item.quantity;
                var bundleSave = bundleOGPrice - bundleSalePrice;

                bundleSave = bundleSave % 1 == 0 ? bundleSave.toFixed(0) : bundleSave.toFixed(2);
                
                var bundleSubscription = item.properties._bundle_group_payment_type;
                var bundleImage = item.properties._bundle_group_image;

                if (item.selling_plan_allocation){
                  bundleSubscriptionInfo = `
                    <p class="monthly-subscription-save">
                      <span class="with-currency-code">${bundleSalePrice}</span> - <span class="fon-monthly">Monthly Subscription (Save <span class="with-currency-code">${bundleSave}</span>)</span>
                    </p>
                  `;
                }

                var bundleInclusions = '';

                // Get Products   
                $.each(cart.items, function(i, item_inclusion) {

                  
                  if (item_inclusion.properties && item_inclusion.properties._bundle_group_id && item_inclusion.properties._bundle_group_id == _bundle_group_id) {

                    let bundleCleanedVariantTitle = (item_inclusion.variant_title) ? item_inclusion.variant_title
                      .replace("Pouches /", "")
                      .replace("Sachets /", "")
                      .trim() : item_inclusion.variant_title;


                    let bundleDiscountedPriceTotal = 0; 
                    let bundleBasePrice = 0; 
                    let bundleSaveTotalDiscount = 0;
                    let bundlePlanID = ''; 


                    // Selling Plan ID for Bundle Properties
                    // const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item_inclusion.product_id));
                    // const bundleCheckVariant = bundleProduct.variants.find(v => String(v.id) === String(item_inclusion.variant_id));
                    // const bundleCheckSellingPlans = bundleCheckVariant.selling_plans;

                    const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));
                    const bundleCheckVariant = bundleProduct?.variants?.find(v => String(v.id) === String(item.variant_id));
                    const bundleCheckSellingPlans = bundleCheckVariant?.selling_plans ?? [];



                    console.log('bundleCheckSellingPlans',bundleCheckSellingPlans);
                    

                    if (bundleProduct && bundleCheckSellingPlans){

                      let bundleVariant = bundleCheckVariant;
                      let bundleSellingPlans = bundleCheckSellingPlans;
                      
                        

                      bundleSellingPlans.forEach(plan => {

                        let displayName = plan.name === 'Ships every 30-days' ? 'Monthly Delivery' : plan.name;
                        let priceAdjustment = plan.adjustment_type;
                        let isPercentage = priceAdjustment === 'percentage';
                        let adjustmentValue = parseFloat(plan.price_adjustment);

                        bundleBasePrice = bundleCheckVariant.price;

                        // Compute discounted price
                        let discountedPrice = isPercentage
                          ? bundleBasePrice - (bundleBasePrice * (adjustmentValue / 100))
                          : bundleBasePrice - adjustmentValue;

                        bundleDiscountedPriceTotal = (discountedPrice - (discountedPrice * (discountPercent / 100))) * item_inclusion.quantity;
                        bundleBasePrice = Math.ceil(bundleBasePrice * item_inclusion.quantity);
                        bundleSaveTotalDiscount = bundleBasePrice - bundleDiscountedPriceTotal;

                        bundleDiscountedPriceTotal = bundleDiscountedPriceTotal % 1 == 0 ? bundleDiscountedPriceTotal.toFixed(0) : bundleDiscountedPriceTotal.toFixed(2);
                        bundleBasePrice = bundleBasePrice % 1 ===0 ? bundleBasePrice.toFixed(0) : bundleBasePrice.toFixed(2);
                        bundleSaveTotalDiscount = bundleSaveTotalDiscount % 1 == 0 ? bundleSaveTotalDiscount.toFixed(0) : bundleSaveTotalDiscount.toFixed(2);
                          
                        bundlePlanID = plan.id;
                      });
                    }
                    
                    let bundleCleanedPackaging = (item_inclusion.variant_title) ? (item_inclusion.variant_title.includes('Pouches')) ? 'Pouch' : 'Sachets' : ''; 
                    // let bundleCleanedPackaging = (item_inclusion.variant_title.includes('Pouches')) ? 'Pouch' : 'Sachets';
                    let bundleInclusionTitle = '';

                    switch (bundleCleanedVariantTitle){
                      case 'Cacao':
                      case 'French Vanilla':
                        bundleInclusionTitle = `1x OneFit Plant-based ${bundleCleanedPackaging}`;
                        bundleInclusionTitle+= ` - <span class="fon-cart-variant-title">${bundleCleanedVariantTitle}</span>`;
                        break;
                      case 'Sachets OneLife / Watermelon':
                        bundleInclusionTitle = `1x OneLife Original Sachets - <span class="fon-cart-variant-title">Original</span>`;
                        break;
                      default:
                        bundleInclusionTitle = `1x OneFit Original ${bundleCleanedPackaging}`;
                        bundleInclusionTitle+= ` - <span class="fon-cart-variant-title">${bundleCleanedVariantTitle}</span>`;
                    }
                    bundleInclusions+=`
                      <span class="inclusion-item inclusion-variant" 
                      data-plan-id="${bundlePlanID}" 
                      data-variant-id="${item_inclusion.variant_id}" 
                      data-quantity="${item_inclusion.quantity}">${bundleInclusionTitle}</span>
                    `;
                  }
                });
                // Get Add Onds   
                $.each(cart.items, function(i, item_inclusion_add_ons) {

                  var bundleBottleIncluded = 0;
                  var bundleFrotherIncluded = 0;

                  if (
                    item_inclusion_add_ons.properties && 
                    item_inclusion_add_ons.properties._bundle_group_id && 
                    item_inclusion_add_ons.properties._bundle_group_id == _bundle_group_id && 
                    item_inclusion_add_ons.properties._bundle_group_product_row == 1) {

                    switch (item.properties._BUNDLE){
                      


                    }

                    totalBundleBottle+=bundleBottleIncluded;
                    totalBundleFrother+=bundleFrotherIncluded;

                  }
                });

                $('.fon-cart-drawer').attr('data-bundle-bottle',totalBundleBottle);
                $('.fon-cart-drawer').attr('data-bundle-frother',totalBundleFrother);


                
                
                
                // const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));
                // const bundleCheckVariant = bundleProduct.variants.find(v => String(v.id) === String(item.variant_id));
                // const bundleCheckSellingPlans = bundleCheckVariant.selling_plans;

                // Feb 2026
                const bundleProduct = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));
                const bundleCheckVariant = bundleProduct?.variants?.find(v => String(v.id) === String(item.variant_id));
                const bundleCheckSellingPlans = bundleCheckVariant?.selling_plans ?? [];

                let bundleBasePrice =  bundleOGPrice % 1 == 0 ? bundleOGPrice.toFixed(0) : bundleOGPrice.toFixed(2);
                let bundleDiscountedPriceTotal = bundleSalePrice % 1 == 0 ? bundleSalePrice.toFixed(0) : bundleSalePrice.toFixed(2);
                let bundleSaveTotalDiscount = bundleBasePrice - bundleDiscountedPriceTotal;
                
                bundleSaveTotalDiscount = bundleSaveTotalDiscount % 1 == 0 ? bundleSaveTotalDiscount.toFixed(0) : bundleSaveTotalDiscount.toFixed(2);


                bundleOGPrice =  bundleOGPrice % 1 == 0 ? bundleOGPrice.toFixed(0) : bundleOGPrice.toFixed(2);
                bundleSalePrice = bundleSalePrice % 1 == 0 ? bundleSalePrice.toFixed(0) : bundleSalePrice.toFixed(2);


                // Shared renderer for all comprehensive (OneFit + OneLife) bundle line
                // items — uses the OneFit line design (flavour dot + name, title, price,
                // serves, sub-line). Quantity unit = anchor line qty / its multiplier.
                var fonCompLine = function (opts) {
                  var vt = item.variant_title || '';
                  // e.g. "OneFit Sachets / Chocolate Milkshake" -> "Chocolate Milkshake".
                  // The brand prefix and doubled spaces have to go or neither the colour
                  // map nor the short-name map will match.
                  var flavour = vt
                    .replace('Pouches /', '').replace('Pouch /', '').replace('Sachets /', '')
                    .replace('Boxes /', '').replace('Box /', '').replace('Tins /', '')
                    .replace(/OneFit®?|OneLife™?/gi, '')
                    .replace(/\s+/g, ' ').trim();
                  var color = (FonCartDrawer.onefitFlavourColors && FonCartDrawer.onefitFlavourColors[flavour.toLowerCase()])
                    || (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[item.sku]) || '';
                  var dot = color ? `<span class="fon-flavour-dot" style="background:${color}"></span>` : '';
                  // "OneFit Chocolate + OneLife Original" — brand back on the short name
                  flavour = 'OneFit ' + FonCartDrawer.shortFlavour(flavour);
                  var fmt = function (v) { v = Number(v); return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2); };
                  var mult = parseInt(item.properties._bundle_group_product_multiplier) || 1;
                  var qty = item.quantity / mult;

                  // Comprehensive always includes the OneLife Watermelon jar — show it as a
                  // second flavour chip alongside the OneFit flavour.
                  var onelifeChip = `<span class="fon-line-flavour--onelife fon-flavour-name">&nbsp;+ OneLife Original</span>`;
                  return `
                        <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-onefit-90d fon-line-item-comprehensive"
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}"
                          data-sku="${item.sku}"
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="${opts.url || '/products/comprehensive'}">
                              <div class="image">
                                <img class="img-fluid" loading="lazy" src="${opts.image ? opts.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_250x250_crop_center$1') : opts.image}" alt="">
                              </div>
                              <div class="text">
                                <p class="fon-line-flavour">${dot}<span class="fon-flavour-name">${flavour}${onelifeChip}</span></p>
                                <h3 class="fon-onefit-title">${opts.title}</h3>
                                <p class="fon-line-desc">
                                  <span class="fon-line-price with-currency-code">${fmt(opts.price)}</span>
                                  <span class="fon-line-sep">|</span>
                                  <span class="fon-line-serves">${opts.serves}</span>
                                </p>
                                <p class="fon-sub-line">${opts.subline}</p>
                              <div class="action justify-content-end">
                                  <div class="fon-quantity" data-qty="${qty}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${qty}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>
                              </div>
                            </div>
                            </div>
                            ${opts.upsell || ''}
                          </div>
                        </div>
                      `;
                };

                switch (item.properties._BUNDLE){
                  

                  case 'onefit_90d_conquesting':

                    // Thumbnail by packaging, from the SKU (-BOX- vs -PCH-).
                    var cqSku = item.sku || '';
                    var cqVt = item.variant_title || '';
                    var cqIsPouch = cqSku
                      ? cqSku.toUpperCase().indexOf('-BOX-') === -1
                      : cqVt.includes('Pouch');
                    var onefit90dImage = FonCartDrawer.bundleThumb(item.sku, 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_OneFit_Thumbnail.webp?v=1777404682');

                    // Get Price Bundle
                    var uBundleQty = 0;
                    var uBundlePrice = 0;
                    var uBundleTitles = '';
                    var cqRows = [];              // one entry per flavour row in the group
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;
                        uBundleQty+= u_item.quantity;

                        uBundleTitles+='<span class="d-block">' + u_item.quantity + 'x ' + u_item.variant_title + '</span>'

                        // A conquesting bundle is one row per chosen flavour, so keep
                        // them all — the line renders a chip for each.
                        cqRows.push({ qty: u_item.quantity, vt: u_item.variant_title || '', sku: u_item.sku || '' });

                      }
                    });

                    var dataURL = '';
                    if (item.properties._order_from){
                      // Any conquesting page: /pages/<handle>, derived from _order_from.
                      var _cqUrl = FonCartDrawer.orderFromUrl(item);
                      if (_cqUrl) dataURL = _cqUrl;
                      switch (item.properties._order_from){
                        case 'conquesting_onefit-vs-protein':
                          dataURL = '/pages/onefit-vs-protein';
                        break;
                        case 'conquesting_onefit-vs-collagen':
                          dataURL = '/pages/onefit-vs-collagen';
                        break;
                      }
                    }

                    var qtyBundle = uBundleQty / 5;
                    totalBottle+= qtyBundle;
                    totalFrother+= qtyBundle ;

                    // Same line design as onefit_90d: flavour dot, price + compare,
                    // unit count, plan sub-line, saving badge.
                    var cqCleanFlavour = function (vt) {
                      return String(vt || '')
                        .replace('Pouches /', '').replace('Pouch /', '').replace('Sachets /', '')
                        .replace('Boxes /', '').replace('Box /', '').replace('Tins /', '')
                        .replace(/OneFit®?|OneLife™?/gi, '')
                        .replace(/\s+/g, ' ').trim();
                    };
                    // One chip per flavour row. Quantity is only shown when the bundle
                    // actually mixes flavours — "2x Chocolate, 3x Tropical".
                    var cqMulti = cqRows.length > 1;
                    var cqChips = (cqRows.length ? cqRows : [{ qty: uBundleQty, vt: cqVt, sku: cqSku }])
                      .map(function (r) {
                        var name = cqCleanFlavour(r.vt);
                        var color = (FonCartDrawer.onefitFlavourColors && FonCartDrawer.onefitFlavourColors[name.toLowerCase()])
                          || (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[r.sku]) || '';
                        var dot = color ? `<span class="fon-flavour-dot" style="background:${color}"></span>` : '';
                        var label = cqMulti ? (r.qty + 'x ' + name) : name;
                        return dot + '<span class="fon-flavour-name">' + label + '</span>';
                      })
                      .join('<span class="fon-flavour-sep">, </span>');
                    var cqUnitCount = uBundleQty;                       // boxes/pouches across the group
                    var cqPackaging = cqIsPouch
                      ? (cqUnitCount === 1 ? 'Pouch' : 'Pouches')
                      : 'Box - Sachets';
                    var cqOrig = FonCartDrawer.originalFromTotal(uBundlePrice * 100, FonCartDrawer.BUNDLE_DISCOUNT['onefit']);
                    var cqCompare = cqOrig ? (cqOrig / 100) : 0;
                    var cqSave = cqCompare - uBundlePrice;
                    var cqFmt = function (v) { v = Number(v); return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2); };

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-onefit-90d"
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}"
                          data-sku="${item.sku}"
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            ${ cqSave > 0 ? `<span class="fon-saving-badge"><img class="fon-saving-badge__icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/ion_pricetags.svg?v=1783445023" alt="" width="12" height="12" loading="lazy">You're Saving <span class="with-currency-code">${cqFmt(cqSave)}</span></span>` : `` }
                            <div class="fon-line-item" data-url="${dataURL}">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}" alt="">
                              </div>
                              <div class="text">
                                <p class="fon-line-flavour">${cqChips}</p>
                                <h3 class="fon-onefit-title">OneFit&reg; Daily Multi-Supplement</h3>
                                <p class="fon-line-desc">
                                  <span class="fon-line-price with-currency-code">${cqFmt(uBundlePrice)}</span>
                                  ${ cqCompare > uBundlePrice ? `<span class="fon-line-compare with-currency-code">${cqFmt(cqCompare)}</span>` : `` }
                                  <span class="fon-line-sep">|</span>
                                  <span class="fon-line-serves">${cqUnitCount}x ${cqPackaging}</span>
                                </p>
                                <p class="fon-sub-line"><span class="fw-600">Plan: </span><span>90-Day Subscription</span></p>
                              <div class="action justify-content-end">
                                  <div class="fon-quantity" data-multiple="5" data-qty="${qtyBundle}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${qtyBundle}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      `;


                  break;


                  case 'unicorn_comprehensive_90d':   // legacy carts — render as standard
                  case 'comprehensive_90d':

                    // Divide by the anchor item's own multiplier (5 for the OneFit line,
                    // 3 for the OneLife line) so the bundle count is correct even when the
                    // fallback anchors on the OneLife line (missing OneFit row-1).
                    var qtyBundleDivisor = parseInt(item.properties._bundle_group_product_multiplier) || 5;
                    var qtyBundle = item.quantity / qtyBundleDivisor;
                    totalOLBottle+= qtyBundle * 2;
                    totalOLFrother+= qtyBundle ;

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-thumb-nofrother_600x600_29ad7d70-8463-472e-a445-344cf1255a50.jpg?v=1790044686&width=250';

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });

                    
                    html+= fonCompLine({
                      image: onefit90dImage,
                      title: 'The Complete System',
                      serves: 'OneFit + OneLife',
                      subline: '<span class="fw-600">Plan: </span>90-Day Subscription',
                      price: uBundlePrice
                    });


                  break;


                  case 'comprehensive_365d':

                    var qtyBundle = item.quantity / 19;
                    totalOLBottle+= qtyBundle * 2;
                    totalOLFrother+= qtyBundle * 2 ; 

                    var onefit90dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-thumb-nofrother_600x600_29ad7d70-8463-472e-a445-344cf1255a50.jpg?v=1790044686&width=250';

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });

                    
                    html+= fonCompLine({
                      image: onefit90dImage,
                      title: 'Comprehensive 365-Day Supply',
                      serves: 'OneFit + OneLife',
                      subline: 'Billed once · Annual',
                      price: uBundlePrice
                    });


                  break;


                  case 'unicorn_comprehensive_30d':   // legacy carts — render as standard
                  case 'comprehensive_30d':

                    var qtyBundle = item.quantity / 2;
                    totalOLBottle+= qtyBundle;
                    totalOLFrother+= qtyBundle ; 

                    // Get Price Bundle
                    var uBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {

                      if (
                        u_item.properties && 
                        u_item.properties._bundle_group_id && 
                        u_item.properties._bundle_group_id == _bundle_group_id && 
                        u_item.properties._bundle_group_product_row){
                          
                        uBundlePrice+= u_item.final_line_price / 100;

                      }
                    });


                    var onefit60dImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-thumb-nofrother_600x600_29ad7d70-8463-472e-a445-344cf1255a50.jpg?v=1790044686&width=250';
                    
                    html+= fonCompLine({
                      image: onefit60dImage,
                      title: 'Comprehensive 30-Day Supply',
                      serves: 'OneFit + OneLife',
                      subline: '<span class="fw-600">Plan: </span>30-Day Subscription',
                      price: uBundlePrice
                    });


                  break;

                  case 'comprehensive_1m':

                    // One-time "Comprehensive One Month" — 2x OneFit + 1x OneLife jar.
                    // No subscription, but it carries the SAME free gifts as the
                    // recurring comprehensive_30d: 1 bottle + 1 frother per bundle.
                    // Anchored on row 1 (the OneFit line, qty 2), exactly as 30d is.
                    var qtyBundle = item.quantity / 2;
                    totalOLBottle+= qtyBundle;
                    totalOLFrother+= qtyBundle;

                    var uTrialBundlePrice = 0;
                    $.each(cart.items, function(u, u_item) {
                      if (
                        u_item.properties &&
                        u_item.properties._bundle_group_id &&
                        u_item.properties._bundle_group_id == _bundle_group_id &&
                        u_item.properties._bundle_group_product_row){

                        uTrialBundlePrice+= u_item.final_line_price / 100;
                      }
                    });

                    var trialImage = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/comprehensive-thumb-nofrother_600x600_29ad7d70-8463-472e-a445-344cf1255a50.jpg?v=1790044686&width=250';

                    html+= fonCompLine({
                      image: trialImage,
                      title: 'Comprehensive One Month',
                      serves: '2x OneFit + 1x OneLife',
                      subline: 'One-time order',
                      price: uTrialBundlePrice,
                      upsell: FonCartDrawer.buildBundle90Upsell('comprehensive-1m', _bundle_group_id, uTrialBundlePrice, item.sku)
                    });


                  break;




                  case 'unicorn_onefit_90d':   // legacy carts — render as standard
                  case 'onefit_90d':

                    // 5 boxes per bundle unless the line says otherwise. A line that
                    // isn't a whole number of bundles (3 boxes read "0.6") is one bundle.
                    var of90Div = parseInt(item.properties._bundle_group_product_multiplier) || 5;
                    if (item.quantity % of90Div !== 0) of90Div = item.quantity;
                    var qtyBundle = item.quantity / of90Div;
                    totalBottle+= qtyBundle;
                    totalFrother+= qtyBundle ;

                    // Image comes from the variant itself (fonBundleThumbs by SKU);
                    // packaging/flavour correctness is inherent, no swap needed.
                    var onefit90dImage = FonCartDrawer.bundleThumb(item.sku, 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_OneFit_Thumbnail.webp?v=1777404682');

                    // Flavour (name + colour by name), packaging, and compare/savings.
                    var of90Vt = item.variant_title || '';
                    // Packaging comes from the SKU: OF-CH-BOX-700-V4.6 vs OF-CM-PCH-700-V4.6.
                    // Anything that isn't a BOX is a pouch. Title is only a fallback.
                    var of90Sku = item.sku || '';
                    var of90IsPouch = of90Sku
                      ? of90Sku.toUpperCase().indexOf('-BOX-') === -1
                      : of90Vt.includes('Pouch');
                    var of90Flavour = of90Vt
                      .replace('Pouches /', '').replace('Sachets /', '')
                      .replace('Boxes /', '').replace('Box /', '').replace('Tins /', '').trim();
                    var of90Color = (FonCartDrawer.onefitFlavourColors && FonCartDrawer.onefitFlavourColors[of90Flavour.toLowerCase()])
                      || (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[item.sku]) || '';
                    var of90Dot = of90Color ? `<span class="fon-flavour-dot" style="background:${of90Color}"></span>` : '';
                    // The line's own quantity IS the unit count — a 90-day bundle is 5 of
                    // the same SKU the one-time product sells (OF-*-BOX-700-V4.6).
                    var of90BoxCount = item.quantity;
                    var of90Packaging = of90IsPouch
                      ? (of90BoxCount === 1 ? 'Pouch' : 'Pouches')
                      : 'Box - Sachets';
                    var of90OneTime = (of90IsPouch ? FonCartDrawer.onefitOneTimeCents.pouch : FonCartDrawer.onefitOneTimeCents.box) / 100;
                    // "Before" price per the advertised SAVE 34% on the PDP card:
                    //   297 / (1 − 0.34) = 450.  Falls back to boxes × one-time price.
                    var _of90Orig = FonCartDrawer.originalFromTotal(finalPrice * 100, FonCartDrawer.BUNDLE_DISCOUNT['onefit']);
                    var of90Compare = _of90Orig ? (_of90Orig / 100) : (of90BoxCount * of90OneTime);
                    var of90Save = of90Compare - finalPrice;
                    var of90Fmt = function (v) { return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2); };

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-onefit-90d"
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}"
                          data-sku="${item.sku}"
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            ${ of90Save > 0 ? `<span class="fon-saving-badge"><img class="fon-saving-badge__icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/ion_pricetags.svg?v=1783445023" alt="" width="12" height="12" loading="lazy">You're Saving <span class="with-currency-code">${of90Fmt(of90Save)}</span></span>` : `` }
                            <div class="fon-line-item" data-url="${FonCartDrawer.orderFromUrl(item) || '/products/onefit'}">
                              <div class="image">
                                <img class="img-fluid" src="${onefit90dImage}" alt="">
                              </div>
                              <div class="text">
                                <p class="fon-line-flavour">${of90Dot}<span class="fon-flavour-name">${of90Flavour}</span></p>
                                <h3 class="fon-onefit-title">OneFit&reg; Daily Multi-Supplement</h3>
                                <p class="fon-line-desc">
                                  <span class="fon-line-price with-currency-code">${of90Fmt(finalPrice)}</span>
                                  <span class="fon-line-compare with-currency-code">${of90Fmt(of90Compare)}</span>
                                  <span class="fon-line-sep">|</span>
                                  <span class="fon-line-serves">${of90BoxCount}x ${of90Packaging}</span>
                                </p>
                                <p class="fon-sub-line"><span class="fw-600">Plan: </span><span>90-Day Subscription</span></p>
                              <div class="action justify-content-end">
                                  <div class="fon-quantity" data-multiple="${of90Div}" data-qty="${qtyBundle}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${qtyBundle}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      `;


                  break;


                  case 'onefit_30d':

                    var of30Qty = item.quantity;          // 1 box per bundle
                    // bottle only — no frother. V4.7 earns the premium frother
                    // and the cap instead (GIFT_RULES.onefit_30d.bySku).
                    var of30Gifts = FonCartDrawer.skuRule(FonCartDrawer.GIFT_RULES.onefit_30d, item.sku);
                    if (of30Gifts) {
                      totalBottle         += of30Qty * of30Gifts.of.b;
                      totalPremiumFrother += of30Qty * (of30Gifts.pf || 0);
                      totalCap            += of30Qty * (of30Gifts.cap || 0);
                    } else {
                      totalBottle += of30Qty;
                    }

                    var of30Vt = item.variant_title || '';
                    var of30Sku = item.sku || '';
                    /* A V4.7 title names its size: "56-serve pouch / Chocolate
                       Milkshake", "28-sachet box / Tropical Crush" (2026-10-14, on
                       request: "40 serves is incorrect ... 56-serve pouch can be
                       Pouch / Flavour ... use the correct serves"). The size gives
                       the serves per unit; V4.6 titles carry none and keep 20.
                       The SKU test also takes V4.7's -BOX28-/-BOX14- forms. */
                    var of30Size = of30Vt.match(/^\s*(\d+)-(?:serve|sachet)\s+(pouch|box)\s*\/\s*(.+)$/i);
                    var of30PerUnit = of30Size ? parseInt(of30Size[1], 10) : 20;
                    var of30IsPouch = of30Size
                      ? /pouch/i.test(of30Size[2])
                      : (of30Sku
                          ? !/-BOX/i.test(of30Sku)
                          : of30Vt.includes('Pouch'));
                    /* The line's own variant image when its SKU is not in the
                       bundle map (2026-10-14, on request: "For pouch thumb, it
                       should be the variant image"). fonBundleThumbs covers only
                       the 90-day bundle products, so a V4.7 line fell through to
                       the generic OneFit thumbnail. Sized as the non-bundle rows. */
                    var of30Own = item.image
                      ? item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_250x250_crop_center$1')
                      : '';
                    var of30Image = FonCartDrawer.bundleThumb(item.sku, of30Own || 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_OneFit_Thumbnail.webp?v=1777404682');
                    var of30Flavour = of30Size ? of30Size[3].trim() : of30Vt
                      .replace('Pouches /', '').replace('Sachets /', '')
                      .replace('Boxes /', '').replace('Box /', '').replace('Tins /', '').trim();
                    var of30Label = of30Size
                      ? (of30IsPouch ? 'Pouch' : 'Sachet Box') + ' / ' + of30Flavour
                      : of30Flavour;
                    var of30Color = (FonCartDrawer.onefitFlavourColors && FonCartDrawer.onefitFlavourColors[of30Flavour.toLowerCase()])
                      || (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[item.sku]) || '';
                    var of30Dot = of30Color ? `<span class="fon-flavour-dot" style="background:${of30Color}"></span>` : '';
                    var of30Packaging = of30IsPouch
                      ? (of30Qty === 1 ? 'One Pouch' : of30Qty + 'x Pouches')
                      : (of30Qty === 1 ? 'One Sachet Box' : of30Qty + 'x Sachet Boxes');
                    var of30Fmt = function (v) { return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2); };

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-onefit-90d"
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}"
                          data-sku="${item.sku}"
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="${FonCartDrawer.orderFromUrl(item) || '/products/onefit'}">
                              <div class="image">
                                <img class="img-fluid" src="${of30Image}" alt="">
                              </div>
                              <div class="text">
                                <p class="fon-line-flavour">${of30Dot}<span class="fon-flavour-name">${of30Label}</span></p>
                                <h3 class="fon-onefit-title">OneFit&reg; Daily Multi-Supplement</h3>
                                <p class="fon-line-desc">
                                  <span class="fon-line-price with-currency-code" data-item-final-price="${finalPrice}">${of30Fmt(finalPrice)}</span>
                                  <span class="fon-line-sep">|</span>
                                  <span class="fon-line-serves">${of30Packaging} - ${of30Qty * of30PerUnit} Serves</span>
                                </p>
                                <p class="fon-sub-line"><span class="fw-600">Plan: </span><span>${FonCartDrawer.planLabel(item, 'Monthly Delivery')}</span></p>
                              <div class="action justify-content-end">
                                  <div class="fon-quantity" data-multiple="1" data-qty="${of30Qty}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${of30Qty}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      `;


                  break;


                  case 'onefit_60d':

                    var qtyBundle = item.quantity / 3;
                    totalBottle+= qtyBundle;
                    totalFrother+= qtyBundle ;

                    // Same card as onefit_90d / the monthly OneFit line: flavour dot,
                    // product name, "price | packaging - serves", plan line.
                    var of60Vt = item.variant_title || '';
                    var of60Sku = item.sku || '';
                    var of60IsPouch = of60Sku
                      ? of60Sku.toUpperCase().indexOf('-BOX-') === -1
                      : of60Vt.includes('Pouch');
                    var onefit60dImage = FonCartDrawer.bundleThumb(item.sku, 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_OneFit_Thumbnail.webp?v=1777404682');
                    var of60Flavour = of60Vt
                      .replace('Pouches /', '').replace('Sachets /', '')
                      .replace('Boxes /', '').replace('Box /', '').replace('Tins /', '').trim();
                    var of60Color = (FonCartDrawer.onefitFlavourColors && FonCartDrawer.onefitFlavourColors[of60Flavour.toLowerCase()])
                      || (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[item.sku]) || '';
                    var of60Dot = of60Color ? `<span class="fon-flavour-dot" style="background:${of60Color}"></span>` : '';
                    // A 60-day bundle is 3 of the same SKU the one-time product sells.
                    var of60BoxCount = item.quantity;
                    var of60Packaging = of60IsPouch
                      ? (of60BoxCount === 1 ? 'One Pouch' : of60BoxCount + 'x Pouches')
                      : (of60BoxCount === 1 ? 'One Sachet Box' : of60BoxCount + 'x Sachet Boxes');
                    var of60Serves = (of60BoxCount * 20) + ' Serves';
                    var of60Fmt = function (v) { return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2); };

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-onefit-90d"
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}"
                          data-sku="${item.sku}"
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="${FonCartDrawer.orderFromUrl(item) || '/products/onefit'}">
                              <div class="image">
                                <img class="img-fluid" src="${onefit60dImage}" alt="">
                              </div>
                              <div class="text">
                                <p class="fon-line-flavour">${of60Dot}<span class="fon-flavour-name">${of60Flavour}</span></p>
                                <h3 class="fon-onefit-title">OneFit&reg; Daily Multi-Supplement</h3>
                                <p class="fon-line-desc">
                                  <span class="fon-line-price with-currency-code" data-item-final-price="${finalPrice}">${of60Fmt(finalPrice)}</span>
                                  <span class="fon-line-sep">|</span>
                                  <span class="fon-line-serves">${of60Packaging} - ${of60Serves}</span>
                                </p>
                                <p class="fon-sub-line"><span class="fw-600">Plan: </span><span>60-Day Subscription</span></p>
                              <div class="action justify-content-end">
                                  <div class="fon-quantity" data-multiple="3" data-qty="${qtyBundle}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${qtyBundle}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      `;


                  break;



                  case 'unicorn_onelife_90d':   // legacy carts — render as standard
                  case 'onelife_90d':

                    var qtyBundle = item.quantity / 3;
                    totalOLBottle+= qtyBundle;
                    totalOLFrother+= qtyBundle ;


                    var dataURL = '/products/onelife';
                    if (item.properties._order_from){
                      // Any conquesting page: /pages/<handle>, derived from _order_from.
                      var _cqUrl = FonCartDrawer.orderFromUrl(item);
                      if (_cqUrl) dataURL = _cqUrl;
                      switch (item.properties._order_from){

                        case 'conquesting_onelife-vs-longevity':
                          dataURL = '/pages/onelife-vs-longevity';
                        break;
                        case 'conquesting_onelife-vs-nmn':
                          dataURL = '/pages/onelife-vs-nmn';
                        break;
                        case 'hybrid':
                          dataURL = '/pages/welcome-onelife';
                        break;
                        case 'pathway_onelife-unicorn':
                          dataURL = '/pages/homepage-quiz';
                        break;

                      }
                    }
                    

                    // OneLife 90-day design: colour, "3x Jar", compare = 3 × one-time jar.
                    var ol90Color = FonCartDrawer.onelifeColor || (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[item.sku]) || '';
                    var ol90Dot = ol90Color ? `<span class="fon-flavour-dot" style="background:${ol90Color}"></span>` : '';
                    var ol90JarCount = qtyBundle * 3;                        // 3 jars per 90-day bundle
                    var ol90OneTime = (FonCartDrawer.onelifeOneTimeCents || 0) / 100;
                    var ol90Compare = ol90JarCount * ol90OneTime;
                    var ol90Save = ol90Compare - finalPrice;
                    var ol90Fmt = function (v) { return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2); };

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-onefit-90d"
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}"
                          data-sku="${item.sku}"
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            ${ ol90Save > 0 ? `<span class="fon-saving-badge"><img class="fon-saving-badge__icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/ion_pricetags.svg?v=1783445023" alt="" width="12" height="12" loading="lazy">You're Saving <span class="with-currency-code">${ol90Fmt(ol90Save)}</span></span>` : `` }
                            <div class="fon-line-item" data-url="${dataURL}">
                              <div class="image">
                                <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneLife_Jar_90d.png?v=1781842081" alt="">
                              </div>
                              <div class="text">
                                <p class="fon-line-flavour">${ol90Dot}<span class="fon-flavour-name">Original</span></p>
                                <h3 class="fon-onefit-title">OneLife&trade; Daily Longevity Blend</h3>
                                <p class="fon-line-desc">
                                  <span class="fon-line-price with-currency-code">${ol90Fmt(finalPrice)}</span>
                                  ${ ol90Compare > finalPrice ? `<span class="fon-line-compare with-currency-code">${ol90Fmt(ol90Compare)}</span>` : `` }
                                  <span class="fon-line-sep">|</span>
                                  <span class="fon-line-serves">${ol90JarCount}x Jars - ${ol90JarCount * 30} Serves</span>
                                </p>
                                <p class="fon-sub-line"><span class="fw-600">Plan: </span><span>90-Day Subscription</span></p>
                              <div class="action justify-content-end">
                                  <div class="fon-quantity" data-multiple="3" data-qty="${qtyBundle}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${qtyBundle}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      `;


                  break;
                  case 'onelife_90d_duo':

                    var qtyBundle = item.quantity / 6;
                    totalOLBottle+= qtyBundle * 2;
                    totalOLFrother+= qtyBundle * 2;


                    var dataURL = '/products/onelife';
                    if (item.properties._order_from){
                      // Any conquesting page: /pages/<handle>, derived from _order_from.
                      var _cqUrl = FonCartDrawer.orderFromUrl(item);
                      if (_cqUrl) dataURL = _cqUrl;
                      switch (item.properties._order_from){

                        case 'conquesting_onelife-vs-longevity':
                          dataURL = '/pages/onelife-vs-longevity';
                        break;
                        case 'conquesting_onelife-vs-nmn':
                          dataURL = '/pages/onelife-vs-nmn';
                        break;

                        case 'hybrid':
                          dataURL = '/pages/welcome-onelife';
                        break;

                      }
                    }
                    

                    // Same line design as onelife_90d. The duo is 6 jars; compare against
                    // 6 one-time jars, exactly as the single bundle compares against 3.
                    var duoJarCount = item.quantity;
                    var duoOneTime = (FonCartDrawer.onelifeOneTimeCents || 0) / 100;
                    var duoCompare = duoJarCount * duoOneTime;
                    var duoSave = duoCompare - finalPrice;
                    var duoColor = FonCartDrawer.onelifeColor || (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[item.sku]) || '';
                    var duoDot = duoColor ? `<span class="fon-flavour-dot" style="background:${duoColor}"></span>` : '';
                    var duoFmt = function (v) { v = Number(v); return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2); };

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-onelife-90d-duo"
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}"
                          data-sku="${item.sku}"
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            ${ duoSave > 0 ? `<span class="fon-saving-badge"><img class="fon-saving-badge__icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/ion_pricetags.svg?v=1783445023" alt="" width="12" height="12" loading="lazy">You're Saving <span class="with-currency-code">${duoFmt(duoSave)}</span></span>` : `` }
                            <div class="fon-line-item" data-url="${dataURL}">
                              <div class="image">
                                <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife_90d_Duo_Product_Card.png?v=1781849497&width=250&height=250&crop=center" alt="">
                              </div>
                              <div class="text">
                                <p class="fon-line-flavour">${duoDot}<span class="fon-flavour-name">Original</span></p>
                                <h3 class="fon-onefit-title">OneLife&trade; Daily Longevity Blend (Duo)</h3>
                                <p class="fon-line-desc">
                                  <span class="fon-line-price with-currency-code">${duoFmt(finalPrice)}</span>
                                  ${ duoCompare > finalPrice ? `<span class="fon-line-compare with-currency-code">${duoFmt(duoCompare)}</span>` : `` }
                                  <span class="fon-line-sep">|</span>
                                  <span class="fon-line-serves">${duoJarCount}x Jars - ${duoJarCount * 30} Serves</span>
                                </p>
                                <p class="fon-sub-line"><span class="fw-600">Plan: </span><span>90-Day Subscription</span></p>
                              <div class="action justify-content-end">
                                  <div class="fon-quantity" data-multiple="6" data-qty="${qtyBundle}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${qtyBundle}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      `;


                  break;
                  case 'onelife_60d':
                  
                    /* 2 jars per delivery, so quantity/2 is the bundle count. Mirrors
                       onelife_30d below; GIFT_RULES carries the same div for the
                       drawer-less path. */
                    var qtyBundle = item.quantity / FonCartDrawer.GIFT_RULES.onelife_60d.div;
                    totalOLBottle+= qtyBundle * FonCartDrawer.GIFT_RULES.onelife_60d.ol.b;
                    totalCap+= qtyBundle * FonCartDrawer.GIFT_RULES.onelife_60d.cap;
                  
                    html+= fonCompLine({
                      image: FonCartDrawer.bundleThumb(item.sku, 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife_Jar_Thumbnail_1.png?v=1781834325'),
                      title: 'OneLife 60-Day Supply',
                      serves: 'OneLife',
                      subline: '<span class="fw-600">Plan: </span>60-Day Subscription',
                      price: (item.final_line_price || 0) / 100
                    });
                  
                  break;
                  
                  case 'onelife_30d':

                    var qtyBundle = item.quantity;
                    totalOLBottle+= qtyBundle;
                    

                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/products/onelife-aus">
                              <div class="image">
                                <img class="img-fluid" src="${FonCartDrawer.bundleThumb(item.sku, 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Onelife_transparent_1500x1500_dc16c241-f123-4722-a01f-bbdf310c94d4.png?crop=center&height=300&v=1760588451&width=300')}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneLife 30-Day Supply</h3>
                                <p>Ships every 30-days</p>
                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              <div class="action justify-content-end">
                              

                                  <div class="fon-quantity"  data-qty="${item.quantity}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>


                              </div>
                            </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;
                  case 'onelife_onetime':

                    var qtyBundle = item.quantity;
                    totalOLBottle+= 1;
                    totalOLFrother+= 1;
                    
                    html+=`
                        <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                          >
                          <div class="fon-line-item-wrapper">
                            <div class="fon-line-item" data-url="/pages/welcome-onelife">
                              <div class="image">
                                <img class="img-fluid" src="${FonCartDrawer.bundleThumb(item.sku, 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Onelife_transparent_1500x1500_dc16c241-f123-4722-a01f-bbdf310c94d4.png?crop=center&height=300&v=1760588451&width=300')}" alt="">
                              </div>
                              <div class="text">
                                <h3 class="bundle-title">OneLife (Try-It Once)</h3>
                                <p>1 Month of OneLife</p>
                                <p class="price">
                                    <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}</span>
                                </p>
                                
                              <div class="action justify-content-end">
                              

                                  <div class="fon-quantity"  data-qty="${item.quantity}">
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                  <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                  <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                  <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                </div>


                              </div>
                            </div>
                            </div>
                            

                          </div>

                          

                        </div>
                      `;


                  break;
                  
                

                  case 'Wholesale':

                        var retailerBundleQty = (item.quantity / 12);

                        bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price) * retailerBundleQty;
                        let wholesaleProductQty = item.quantity;

                        totalWSWelcomeKit+= retailerBundleQty;
                        totalWSBottle+=5 * retailerBundleQty;
                        totalWSFrother+=5 * retailerBundleQty;

                        var retailerOneFitQty = retailerBundleQty * 12;


                        html+=`
                          <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-wholesale-row fon-line-item-wholesale-row-kitx" 
                              data-bundle-group-id="${_bundle_group_id}"
                              data-variant-id="${item.variant_id}" 
                              data-sku="${item.sku}" 
                              data-product-id="${item.product_id}"
                              data-line-key="${item.key}"
                          >
                            <div class="fon-line-item-wrapper">
                              <div class="fon-line-item">
                                <div class="image">
                                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Portal_Welcome_Kit.png?v=1761797300" alt="">
                                </div>
                                <div class="text">
                                  <h3 class="bundle-title">Retailers Essentials Bundle</h3>
                                  <div class="lineitem-bundle-inclusions"><strong>Contents:</strong> ${retailerOneFitQty}x OneFit Sachet Boxes, ${retailerOneFitQty}x OneFit Pouches</div>
                                  
                                  
                                  ${
                                  item.selling_plan_allocation
                                      ? ``
                                      : `
                                        <p class="price">
                                          <span class="price-new with-currency-code" data-item-final-price="${bundleOGPrice}">${bundleOGPrice}</span>
                                        </p>
                                      `
                                  }
                                  ${bundleSubscriptionInfo}
                                <div class="action justify-content-end">
                                

                                    <div class="fon-quantity" data-multiple-ws="12" data-qty="${ (item.quantity / 12 ) }">  
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="${ (item.quantity / 12 ) }" min="0"/>
                                    <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                    </div>
                                    


                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        `;
                      break;

                      // <div class="fon-quantity" data-qty="1">
                      //               <input name="fon-qty" class="form-control fon-qty" type="number" value="1" min="0"/>
                      //               <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                      //               </div>
                                    

                      case 'Wholesale Mix & Match':

                        bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price);
                        var mixMatch = item.quantity;
                        var wholesaleDescription = item.properties._bundle_group_description;

                        html+=`
                          <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-wholesale-row fon-line-item-wholesale-row-mix" 
                              data-bundle-group-id="${_bundle_group_id}"
                              data-variant-id="${item.variant_id}" 
                              data-sku="${item.sku}" 
                              data-product-id="${item.product_id}"
                              data-line-key="${item.key}"
                          >
                            <div class="fon-line-item-wrapper">
                              <div class="fon-line-item">
                                <div class="image">
                                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Promo_Kit_Image.png?v=1762402294" alt="">
                                </div>
                                <div class="text">
                                  <h3 class="bundle-title">Retailers Mix & Match</h3>
                                  ${ wholesaleDescription ? `<div class="lineitem-bundle-inclusions">${wholesaleDescription}</div>` : ``}
                                <div class="action justify-content-end">
                                

                                    
                                    <div class="fon-quantity" data-qty="1">
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="1" min="0"/>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                    </div>
                                    


                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        `;
                      break;

                      case 'Wholesale Product':

                        var isAccessory = false;
                        var wholesaleDescription = item.properties._bundle_group_description;
                        
                        // alert(productTitle);
                        // Get Title
                        if (  
                              productTitle.includes("Retailers") && item.variant_title && !item.variant_title.includes("Bottle") && !item.variant_title.includes("Frother")
                          ) {
                          let cleanedVariantTitle = item.variant_title
                            .replace("OneFit ", "")
                            .replace("Pouches /", "")
                            .replace("Sachets /", "")
                            .trim();


                          if (item.variant_title.includes('Sachets')){
                            if (item.variant_title.includes('Cacao') || item.variant_title.includes('French Vanilla')){
                              productTitle+= '<span class="wholesale d-block">OneFit Plant-based: Sachets <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }else{
                              productTitle+= '<span class="wholesale d-block">OneFit Original: Sachets <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }
                          }else{
                            if (item.variant_title.includes('Cacao') || item.variant_title.includes('French Vanilla')){
                              productTitle+= '<span class="wholesale d-block">OneFit Plant-based: Pouch <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }else{
                              productTitle+= '<span class="wholesale d-block">OneFit Original: Pouch <span class="d-block fon-cart-variant-title">'+cleanedVariantTitle+'</span</span>';
                            }
                          }

                        }


                        if (  
                              productTitle.includes("Retailers") && item.variant_title &&  
                              (item.variant_title.includes("Promo Kit") || 
                              item.variant_title.includes("Bottle") || 
                              item.variant_title.includes("Frother") )
                          ) {
                          let cleanedVariantTitle = item.variant_title
                            .replace("OneFit ", "")
                            .replace("Pouches /", "")
                            .replace("Sachets /", "")
                            .replace("Accessories /", "")
                            .replace("Kits /", "")
                            .trim();

                          // wholesaleDescription = '';
                          productTitle = '';
                          productTitle+= `Retailers <span class="wholesale d-block"><span class="d-block fon-cart-variant-title">${item.quantity}x ${cleanedVariantTitle}</span</span>`;
                            isAccessory = true;
                        }

                        // Get Image
                        let productImage = item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_250x250_crop_center$1');
                        const product = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));

                        // let check_variant = product.variants.find(v => String(v.id) === String(item.variant_id));
                        // let check_sellingPlans = check_variant.selling_plans;

                        // Feb 23, 2026
                        let check_variant = (product?.variants ?? []).find(
                          v => String(v.id) === String(item.variant_id)
                        );


                        let check_sellingPlans = check_variant?.selling_plans ?? [];

                        // Product Thumbnail
                        // if (product){
                        //   let variant = product.variants.find(v => String(v.id) === String(item.variant_id));
                        //   if (variant){
                        //     productImage = variant.thumbnail;
                        //   }
                        // }

                        bundleOGPrice = parseFloat(item.properties._bundle_group_oneitem_price);
                        
                        let wholesaleQuantity = item.quantity;

                        // totalWSWelcomeKit++;
                        // totalWSBottle+=5;
                        // totalWSFrother+=5;

                        // KITS - Promo Kit
                        if (productTitle.includes('Promo Kit')){
                          totalWSBottle+= item.quantity * 10;
                          totalWSFrother+= item.quantity * 10;
                        }


                        var wsProductQty = item.quantity / 6;


                        if (productTitle.includes('Sachets')){

                          if (wsProductQty == 1){
                            wholesaleDescription = `1 Carton = 6 × 20 sachets (120 total)`;
                          }else{
                            var wsProductTotal = item.quantity * 20;
                            wholesaleDescription = `${wsProductQty} Cartons = ${item.quantity} × 20 sachets (${wsProductTotal} total)`;
                          }
                          
                          isAccessory = false;
                        }
                        if (productTitle.includes('Pouch')){

                          if (wsProductQty == 1){
                            wholesaleDescription = `1 Carton = 6 Pouches (4.2 kgs in total)`;
                          }else{
                            var wsProductTotal = wsProductQty * 4.2;
                            wholesaleDescription = `${wsProductQty} = ${item.quantity} Pouches (${wsProductTotal} kgs in total)`;
                          }
                          isAccessory = false;

                        }

                        html+=`
                          <div class="fon-line-item-row fon-line-item-bundle-row fon-line-item-wholesale-row ${ isAccessory ? 'fon-line-item-wholesale-accessory' : '' }" 
                              data-bundle-group-id="${_bundle_group_id}"
                              data-variant-id="${item.variant_id}" 
                              data-sku="${item.sku}" 
                              data-product-id="${item.product_id}"
                              data-line-key="${item.key}"
                              
                          >
                            <div class="fon-line-item-wrapper">
                              <div class="fon-line-item">
                                <div class="image">
                                  <img class="img-fluid" src="${productImage}" alt="">
                                </div>
                                <div class="text">
                                  <h3 class="bundle-title">${productTitle}</h3>

                                  ${ wholesaleDescription ? `<div class="lineitem-bundle-inclusions">${wholesaleDescription}</div>` : ``}
                                  
                                  ${ originalPrice == finalPriceWS ? 
                                  
                                    `<p class="price">
                                          <span class="price-new with-currency-code" data-item-final-price="${finalPriceWS}">${finalPriceWS}</span>
                                        </p>`
                                    : 
                                      `<p class="price">
                                      <span class="price-old with-currency-code">${originalPrice}</span>
                                      <span class="price-new with-currency-code" data-item-final-price="${finalPriceWS}">${finalPriceWS}</span>
                                    </p>`
                                    
                                  }


                                  ${bundleSubscriptionInfo}
                                <div class="action justify-content-end">
                                

                                    ${ isAccessory ? `
                                    <div class="fon-quantity" data-qty="${item.quantity}">  
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                    <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                    </div>
                                    ` : 
                                  `<div class="fon-quantity" data-multiple="6" data-qty="${ (item.quantity / 6 ) }">  
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                    <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                    <input name="fon-qty" class="form-control fon-qty" type="number" value="${ (item.quantity / 6 ) }" min="0"/>
                                    <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                                    </div>`
                                    }


                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        `;
                      break;

                  case 'Weekly Billing':

                    bundleOGPrice = item.price;
                    html+=`
                      <div class="fon-line-item-row fon-line-item-bundle-row" 
                          data-bundle-group-id="${_bundle_group_id}"
                          data-variant-id="${item.variant_id}" 
                          data-sku="${item.sku}" 
                          data-product-id="${item.product_id}"
                          data-line-key="${item.key}"
                      >
                        <div class="fon-line-item-wrapper">
                          <div class="fon-line-item" data-url="/products/onefit-sachets">
                            <div class="image">
                              <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/CHOC-MILKSHAKE-SACHETS_NO-BG.png?crop=center&height=300&v=1760415230&width=300" alt="">
                            </div>
                            <div class="text">
                              <h3 class="bundle-title">OneFit Weekly Plan</h3>
                              
                              <div class="lineitem-bundle-inclusions">Contents: <strong>OneFit Original: Sachets</strong> <span>Chocolate Milkshake</span>, Marathon Bottle</div>
                              <p class="price">
                                <span class="price-new with-currency-code" data-item-final-price="${finalPrice}">${finalPrice}/week</span>
                              </p>
                            <div class="action justify-content-end">
                             

                                <div class="fon-quantity" data-qty="${item.quantity}">
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                                <button class="fon-qty-btn  fon-qty-bundle-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                                <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                                <button class="fon-qty-btn fon-qty-bundle-btn " data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                              </div>


                            </div>
                          </div>
                          </div>
                        </div>
                      </div>
                    `;
                  break;
                
                                  
          
              }
              bundlesActive.push(_bundle_group_id);
            }

            return;
            
          }

       


          if (  
            productTitle.includes("OneLife:")
            ) {
            productTitle = 'OneLife NMN Blend<span class="d-block">Original</span>';
          }
         

          if (  
                productTitle.includes("OneFit:") &&
                !productTitle.includes("OneFit Plant-based:") 
            ) {
            productTitle = productTitle.replace("OneFit:","OneFit Original:");
          }
          
          if (  
                productTitle.includes("OneFit Original:") || 
                productTitle.includes("OneFit Plant-based:") || 
                productTitle.includes("OneLife:")
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();

            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;
          }


          if (  
                productTitle == "OneFit" ||
                productTitle == "OneFit [B]" ||
                productTitle == "OneFit [B] 30-Day Supply" ||
                productTitle == "OneFit 30-Day Supply"
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();  
            productTitle = 'OneFit® Daily Multi-Supplement';
            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;
          }
          if (  
                productTitle == "Comprehensive"
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();  
            productTitle = 'Comprehensive';
            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span><span class="fw-400">OneLife</span>`;
          }

           if (  
                productTitle == 'OneLife'
            ) {
            const cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();  
            productTitle = 'OneLife™ Daily Longevity Blend';
            // productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;
          }

          

          var paymentTypeLabel = paymentType;

 
          if (paymentType == 'Ships every 30-days'){
            paymentTypeLabel = 'Monthly Delivery';

            if (!hasBundle){

              totalFrother++;
              totalBottle++;
            }


            let adjustment = item?.selling_plan_allocation?.selling_plan?.price_adjustments?.[0];

            if (adjustment) {
              let originalPrice = item.original_price / 100; // Shopify returns price in cents

              if (adjustment.value_type === 'percentage') {
                // percentage discount
                discountAmount = (originalPrice * adjustment.value) / 100;
              } else if (adjustment.value_type === 'fixed_amount') {
                // fixed amount discount (convert from cents)
                discountAmount = adjustment.value / 100;
              }
            }

            // Round up the discount amount
            discountAmount = Math.ceil(discountAmount);

          }
          

          var optionMultiplier = 1;
          var optionText = '';
          var optionTotalTake = 0;

          
          if (productTitle.includes("OneFit")) {

            let basisServe = 20;
            optionMultiplier = (paymentTypeLabel == '12-Month Supply') ? 12 : 1;
            optionTotalTake = (item.quantity * (basisServe * optionMultiplier) );

            var packageName = item.variant_title;

            // Check for 12 months
            if (productTitle.includes("Tins") || productTitle.includes("Tin")){
              packageName = 'Tins';
            }else if (productTitle.includes("Sachets") || productTitle.includes("Sachet")){
              packageName = 'Sachets';
            }else if (productTitle.includes("Pouches") || productTitle.includes("Pouch")){
              packageName = 'Pouches';
            }else{

            }

            switch (packageName){
              case 'Tins':
              case 'Pouches':
              case 'Pouch':
                optionText = `Scoops: <span>` + optionTotalTake + '</span>';
                
              break;
              case 'Sachets':
                optionText = `<span>Purchasing ` + optionTotalTake + ' Sachets</span>';
              break;
            }
          }else if (productTitle.includes("OneLife")) {

            let basisServe = 30;
            optionMultiplier = (paymentTypeLabel == '12-Month Supply') ? 12 : 1;
            optionTotalTake = (item.quantity * (basisServe * optionMultiplier) );

            optionText = `<span>Purchasing ` + optionTotalTake + ' Sachets</span>';

          }else{
            optionText = '';
          }


          if (productTitle.includes("The Starter")) {

            let cleanedVariantTitle = item.variant_title
              .replace("Pouches /", "")
              .replace("Sachets /", "")
              .trim();

            let cleanedPackaging = (item.variant_title.includes('Pouches')) ? 'Pouch' : 'Sachets';

            switch (cleanedVariantTitle){
              case 'Cacao':
              case 'French Vanilla':
                cleanedVariantTitle = `OneFit Plant-based: ${cleanedPackaging}<br>` + cleanedVariantTitle;
                break;
              default:
                cleanedVariantTitle = `OneFit Original: ${cleanedPackaging}<br>` + cleanedVariantTitle;
            }


            productTitle += `<span class="d-block fon-cart-variant-title">${cleanedVariantTitle}</span>`;

            
            

          }


          let discountedPriceTotal = 0; //finalPrice.toFixed(2);
          let basePrice = 0; //originalPrice.toFixed(2);
          let variant;
          let sellingPlans;
          let saveTotalDiscount = 0;
          let planID;
          let productImage = item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_250x250_crop_center$1');

          const product = FonCartDrawer.productData.find(p => String(p.id) === String(item.product_id));

          // let check_variant = product.variants.find(v => String(v.id) === String(item.variant_id));
          // let check_sellingPlans = check_variant.selling_plans;

          let check_variant = (product?.variants ?? []).find(
            v => String(v.id) === String(item.variant_id)
          );

          let check_sellingPlans = check_variant?.selling_plans ?? [];

     


          // Product Thumbnail
          if (product){

            let variant = product.variants.find(v => String(v.id) === String(item.variant_id));
            if (variant){
              productImage = variant.thumbnail;
            }
          }


          if (product && !item.selling_plan_allocation){

            let variant = product.variants.find(v => String(v.id) === String(item.variant_id));
            let sellingPlans = variant?.selling_plans || [];
            
            if (variant && sellingPlans){

              
              sellingPlans.forEach(plan => {
                let displayName = plan.name === 'Ships every 30-days' ? 'Monthly Delivery' : plan.name;
                let priceAdjustment = plan.adjustment_type;
                let isPercentage = priceAdjustment === 'percentage';
                let adjustmentValue = parseFloat(plan.price_adjustment);

                basePrice = variant.price;

                // Compute discounted price
                discountedPrice = isPercentage
                  ? basePrice - (basePrice * (adjustmentValue / 100))
                  : basePrice - adjustmentValue;

                discountedPriceTotal = (discountedPrice - (discountedPrice * (discountPercent / 100))) * item.quantity;

                

                // Round up values
                basePrice = Math.ceil(basePrice * item.quantity);
                // discountedPriceTotal = Math.ceil(discountedPriceTotal);
                // discountedPriceTotal = Math.floor(discountedPriceTotal); // Convert to floor

                // if (hasDiscount) {
                //   basePrice = parseFloat(basePrice.toFixed(2));
                //   discountedPriceTotal = parseFloat(discountedPriceTotal.toFixed(2));
                // }

                // Calculate total savings
                saveTotalDiscount = basePrice - discountedPriceTotal;

                // Optional: clean .00 for display
                // basePrice = basePrice % 1 === 0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                // discountedPriceTotal = discountedPriceTotal % 1 === 0 ? discountedPriceTotal.toFixed(0) : discountedPriceTotal.toFixed(2);
                // saveTotalDiscount = saveTotalDiscount % 1 === 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);

                // if ($('.country-AU').length){
                //   discountedPriceTotal = discountedPriceTotal.toFixed(0);
                //   basePrice = basePrice % 1 === 0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                //   saveTotalDiscount = saveTotalDiscount % 1 === 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);
                // }else{
                //   discountedPriceTotal = discountedPriceTotal.toFixed(2);
                //   basePrice = basePrice % 1 === 0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                //   saveTotalDiscount = saveTotalDiscount % 1 === 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);
                // }

                discountedPriceTotal = discountedPriceTotal % 1 == 0 ? discountedPriceTotal.toFixed(0) : discountedPriceTotal.toFixed(2);
                basePrice = basePrice % 1 ===0 ? basePrice.toFixed(0) : basePrice.toFixed(2);
                saveTotalDiscount = saveTotalDiscount % 1 == 0 ? saveTotalDiscount.toFixed(0) : saveTotalDiscount.toFixed(2);
                  
                planID = plan.id;
              });
            }
          }

          // <ul class="fon-item-properties">
          //             ${
          //               item.properties && Object.keys(item.properties).length
          //                 ? Object.entries(item.properties)
          //                     .map(([key, value]) => {
          //                       // skip properties that start with "_" or have empty values
          //                       if (value && !key.startsWith("_")) {
          //                         return `<li><strong>${key}:</strong> ${value}</li>`;
          //                       }
          //                       return "";
          //                     })
          //                     .join("")
          //                 : ``
          //             }
          //           </ul>


   

          let finalPriceUpdate = finalPrice % 1 === 0 ? finalPrice.toFixed(0) : finalPrice.toFixed(2);
          let originalPriceUpdate = originalPrice % 1 === 0 ? originalPrice.toFixed(0) : originalPrice.toFixed(2);


          var dataURL = item.url;
          if (item.properties._order_from){
            // Any conquesting page: /pages/<handle>, derived from _order_from.
            var _cqUrl = FonCartDrawer.orderFromUrl(item);
            if (_cqUrl) dataURL = _cqUrl;
            switch (item.properties._order_from){
              case 'conquesting_onefit-vs-protein':
                dataURL = '/pages/onefit-vs-protein';
              break;
              case 'conquesting_onefit-vs-collagen':
                dataURL = '/pages/onefit-vs-collagen';
              break;
              case 'onefit-main':
                dataURL = '/products/onefit';
              break;
              case 'onefit-challenger':
                dataURL = '/products/onefit';
              break;
              case 'onefit-short':
                dataURL = '/products/onefit?view=onefit-2026-b-shorter';
              break;
              case 'onefit-offers':
                dataURL = '/products/onefit?view=onefit-offers';
              break;
              case 'onefit-offer30':
                dataURL = '/products/onefit?view=onefit-offer30';
              break;
              case 'onefit-deal':
                dataURL = '/pages/onefit-deal';
                if (totalBottle > 0){
                  totalBottle-=1;
                }
                
              break;
              case 'conquesting_onelife-vs-nmn':
                dataURL = '/pages/onelife-vs-nmn';

                // Freebie removed — gifts now come only from the standard bundle rules.

              break;
              case 'conquesting_onelife-vs-longevity':
                dataURL = '/pages/onelife-vs-longevity';

                // Freebie removed — gifts now come only from the standard bundle rules.

              break;

              case 'hybrid':
                dataURL = '/pages/welcome-onelife';
              break;
              case 'b2g1':
              case 'b3g2':
                dataURL = '/pages/holiday-special';
              break;
            }
          }

          // HS
          if (productTitle == 'Holiday Special'){
            var HSVariantTitle = item.title.replace('Holiday Special - ','');
            productTitle+= '<span class="d-block" style="font-size: 10px;opacity: .5;">' + HSVariantTitle + '</span>';
          }

          // ---- OneFit / OneLife-jar line-item design: flavour dot + packaging/serves ----
          // Design line = any OneFit / OneLife product line (standard products, Holiday
          // Special, etc.). Detected by handle, SKU prefix, or product name in the title.
          var _sku = item.sku || '';
          var _vtl = item.variant_title || '';
          var fonIsOneFitLine  = item.handle === 'onefit-b' || item.handle === 'onefit'
            || _sku.indexOf('OF-') === 0 || _vtl.indexOf('OneFit') !== -1;
          var fonIsOneLifeLine = item.handle === 'onelife-jar'
            || _sku.indexOf('OL-') === 0 || _vtl.indexOf('OneLife') !== -1 || _vtl.indexOf('Jar') !== -1;
          // If a title somehow matches both, treat it as OneFit.
          if (fonIsOneFitLine) fonIsOneLifeLine = false;
          var fonIsDesignLine  = fonIsOneFitLine || fonIsOneLifeLine;
          // Colour by SKU (from all_products map), falling back to the productData variant.
          var fonFlavourColor = (FonCartDrawer.flavourColors && FonCartDrawer.flavourColors[item.sku])
            || (check_variant && check_variant.color)
            || '';
          // Flavour = the part after the last "/" (e.g. "OneFit Sachets / Tropical Crush"
          // -> "Tropical Crush"), with any product name stripped.
          var fonFlavourName = (_vtl.indexOf('/') !== -1 ? _vtl.split('/').pop() : _vtl)
            .replace(/OneFit®?|OneLife™?/gi, '').trim();
          // OneLife's only flavour is branded "Original", not by its variant name
          if (fonIsOneLifeLine && /Watermelon/i.test(fonFlavourName)) fonFlavourName = 'Original';
          var fonFlavourDot = fonFlavourColor
            ? `<span class="fon-flavour-dot" style="background:${fonFlavourColor}"></span>` : '';

          // Packaging label + serves (OneFit = 20 serves/unit, OneLife jar = 30 serves/jar)
          // Count words: 1 -> "One X", 2 -> "Two X", 3+ -> "3x X".
          var _vt = item.variant_title || '';
          var _countWord = function (n, singular, plural) {
            if (n === 1) return 'One ' + singular;
            if (n === 2) return 'Two ' + plural;
            return n + 'x ' + plural;
          };
          /* Matched in any case, and the serves read off the format's name when
             it carries a count: V4.7's formats are "28-sachet box", "56-serve
             pouch" and "14-sachet box" (Sep 29), where V4.6's "Sachets" /
             "Pouches" are 20 serves a unit. */
          var _vtLc = _vt.toLowerCase();
          var fonPackaging = '';
          if (fonIsOneLifeLine || _vt.includes('Jar')) fonPackaging = _countWord(item.quantity, 'Jar', 'Jars');
          else if (_vtLc.includes('pouch'))  fonPackaging = _countWord(item.quantity, 'Pouch', 'Pouches');
          else if (_vtLc.includes('sachet')) fonPackaging = _countWord(item.quantity, 'Sachet Box', 'Sachet Boxes');
          else if (_vt.includes('Tin'))    fonPackaging = _countWord(item.quantity, 'Tin', 'Tins');
          var _perUnit = fonIsOneLifeLine ? 30 : 20;
          var _named = /(\d+)\s*-?\s*(sachet|serve)/i.exec(_vt.split('/')[0] || '');
          if (_named) _perUnit = parseInt(_named[1], 10);
          var fonServes = (item.quantity * _perUnit) + ' Serves';

          /* Free units from a Buy X Get Y discount (2026-10-19: Renz's automatic
             OF56-HS-B2G1 / OF56-HS-B3G2 on the holiday special's 4.7 pouches).
             Shopify takes the free pouch off the line's price, so three pouches
             read as $358 with nothing saying one was free. A 100%-off allocation
             is a "get" unit; its amount over the unit price is how many. */
          var fonFreeUnits = 0;
          (item.line_level_discount_allocations || []).forEach(function (a) {
            var app = a.discount_application || {};
            var isFreeUnit = (app.value_type === 'percentage' && parseFloat(app.value) === 100)
              || /\bB\d+G\d+\b/i.test(app.title || '');
            if (isFreeUnit && item.original_price > 0) fonFreeUnits += Math.round(a.amount / item.original_price);
          });
          var fonPriceHtml = fonFreeUnits
            ? `<s class="fon-line-price-old with-currency-code">${originalPriceUpdate}</s>`
              + (finalPrice === 0
                ? `<span class="fon-line-price fon-line-price-free">FREE</span>`
                : `<span class="fon-line-price with-currency-code">${finalPriceUpdate}</span><span class="fon-line-free">${fonFreeUnits} Free</span>`)
            : `<span class="fon-line-price with-currency-code">${finalPriceUpdate}</span>`;

          // Subscription label
          var fonSubLabel = item.selling_plan_allocation
            ? (item.selling_plan_allocation.selling_plan.name || 'Subscription')
            : 'One Time Purchase';
          if (fonSubLabel === 'Ships every 30-days') fonSubLabel = 'Monthly Delivery';

          // Title without the embedded flavour sub-span (flavour shown on the dot line)
          var fonTitleMain = productTitle.replace(/<span class="d-block fon-cart-variant-title">[\s\S]*?<\/span>/, '')
            // The holiday special's own product (onefit-holiday-special, 2026-10-19) is
            // "OneFit® Daily Multi-Supplement (HS)"; the (HS) is an admin tag, not a name.
            .replace(/\s*\(HS\)/, '');
          // Use the same product name the bundle rows show, not the raw Shopify title
          if (/OneLife\s*Jar/i.test(fonTitleMain)) {
            fonTitleMain = 'OneLife&trade; Daily Longevity Blend';
          }

          html += `
            <div class="fon-line-item-row line-item-${item.variant_id} ${paymentType == '12-month Supply' ? `fon-line-item-row-12-months` : ``}" 
            
              data-variant-id="${item.variant_id}" 
              data-sku="${item.sku}" 
              data-product-id="${item.product_id}"
              data-line-key="${item.key}"
              
              >
              <div class="fon-line-item-wrapper">
                <div class="fon-line-item" data-url="${dataURL}">
                  <div class="image">
                    <img class="img-fluid" src="${productImage}" alt="${item.product_title}" />
                  </div>
                  <div class="text">
                    ${ fonIsDesignLine ? `
                      <p class="fon-line-flavour">${fonFlavourDot}<span class="fon-flavour-name">${fonFlavourName}</span></p>
                      <h3 class="fon-onefit-title">${fonTitleMain}</h3>
                      <p class="fon-line-desc">
                        ${fonPriceHtml}
                        <span class="fon-line-sep">|</span>
                        <span class="fon-line-serves">${fonPackaging} - ${fonServes}</span>
                      </p>
                      <p class="fon-sub-line"><span class="fw-600">Plan: </span><span>${fonSubLabel}</span></p>
                    ` : `
                      <h3>${productTitle}</h3>

                      ${hasDiscount ? `

                        ${item.selling_plan_allocation ?
                          `<p class="monthly-subscription-save">
                            <span class="with-currency-code">${finalPriceUpdate}</span> - <span class="fon-monthly">Monthly Subscription</span>
                            </p>`
                          :
                          `<p class="price">
                            <span class="price-old with-currency-code">${originalPriceUpdate}</span>
                            <span class="price-new with-currency-code" data-item-final-price="${finalPrice.toFixed(2)}">${finalPriceUpdate}</span>
                          </p>
                          `
                        }

                      ` : `

                        ${item.selling_plan_allocation ?
                          `<p class="monthly-subscription-save">
                            <span class="with-currency-code">${finalPriceUpdate}</span> - <span class="fon-monthly">Monthly Subscription</span>
                            </p>`
                          :
                          `<p class="price">
                            <span class="price-new with-currency-code">${originalPriceUpdate}</span>
                          </p>`
                        }

                      `}
                    ` }
                  <div class="action justify-content-end">
                    <div class="fon-quantity" data-qty="${item.quantity}">
                      <button class="fon-qty-btn fon-trash-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/carbon_trash-can.svg?v=1783643628"></span></button>
                      <button class="fon-qty-btn fon-less-btn" data-action="minus" type="button"><span><img alt="Minus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Line_58.png?v=1759909385"></span></button>
                      <input name="fon-qty" class="form-control fon-qty" type="number" value="${item.quantity}" min="0"/>
                      <button class="fon-qty-btn" data-action="plus" type="button"><span><img alt="plus" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682"></span></button>
                    </div>
                  </div>
                </div>
                </div>
                    
               
                ${ product && (item.product_title != 'OneFit') && check_variant && check_sellingPlans.length && !item.selling_plan_allocation
                  ? `
                    <div class="fon-subscribe-save-wrapperx">
                      <p class="fon-save-label">Subscribe & Save <span class="with-currency-code amount">${saveTotalDiscount}</span></p>
                      <p class="pause-anytime"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Pause_Anytime.svg?v=1760332895" alt="Pause Anytime"/> Pause, adjust flavours, cancel any time</p>
                      <p class="prices">
                        <span class="new with-currency-code">${discountedPriceTotal}/mo</span>
                        <span class="old">vs. <span class="with-currency-code"></span>${basePrice}</span>
                      </p>
                      <button class="btn-upgrade" type="button" data-plan-id="${planID}">Upgrade now</button>
                    </div>
                    `
                  : ''
                }


                ${FonCartDrawer.buildLineItemUpsell(item)}

              </div>

              
          `;
          html+=`<div class="fon-subscribe-save-wrapper">`;
          
          

          if (item.selling_plan_allocation ) {
            totalSubscriptionCount++;

            let subscribeSuccess = `You’re Saving With a Subscription!`;
            
            if (paymentType == '12-month Supply'){
              
              subscribeSuccess = `You’re Saving With a Subscription!`;

            }

            html+=`
                <div class="fon-line-item-subscribe-save checked">
                  <div class="fon-toggle-box subscribe-save-remove"><img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498"/></div>
                  <div class="fon-text">${subscribeSuccess}</div>
                </div>`;
            
  
          }
    
          html += `
              </div> <!-- close fon-subscribe-save-wrapper -->`;


          
                
          html+=`
            </div> <!-- close fon-line-item-row -->
          `;
        });

        // Per-bundle free-gift totals (see CLAUDE.md). Consumed by the checkout handler.
        //   OneFit gifts  -> totalBottle / totalFrother
        //   OneLife gifts -> totalOLBottle / totalOLFrother  (onelife + comprehensive)
        if (FonCartDrawer.BOTTLE_GIFTS_DISABLED) { totalBottle = 0; totalOLBottle = 0; }
        if (FonCartDrawer.FROTHER_GIFTS_DISABLED) { totalFrother = 0; totalOLFrother = 0; }
        if (FonCartDrawer.usOnly()) { totalBottle = 0; totalFrother = 0; totalOLBottle = 0; totalOLFrother = 0; totalPremiumFrother = 0; totalCap = 0; }
        FonCartDrawer.freeGiftTotals = FonCartDrawer.capGifts({
          bottle:    totalBottle,
          frother:   totalFrother,
          olBottle:  totalOLBottle,
          olFrother: totalOLFrother,
          premiumFrother: totalPremiumFrother,
          cap:            totalCap
        }, cart);
        // The rows below draw from the capped totals, so "Free 2x" cannot show.
        totalBottle = FonCartDrawer.freeGiftTotals.bottle;
        totalFrother = FonCartDrawer.freeGiftTotals.frother;
        totalOLBottle = FonCartDrawer.freeGiftTotals.olBottle;
        totalOLFrother = FonCartDrawer.freeGiftTotals.olFrother;
        totalPremiumFrother = FonCartDrawer.freeGiftTotals.premiumFrother;
        totalCap = FonCartDrawer.freeGiftTotals.cap;

        // Free Item
          if (totalBottle > 0 && !bottleOOS){

          var totalFreeBottleSaving = totalBottle * bottlePrice;
          html += `
            <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-bottle-row">
              <div class="fon-line-item fon-line-item-free-bottle" data-total="${totalBottle}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x.png?v=1779342543" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>Free ${totalBottle}x Premium Bottle</h3>    
                  <p class="packaging">
                    <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
                    <span>Free gift for subscribers</span>
                  </p>
                 
                </div>
                <div class="action">
                  <span class="free-saving with-currency-code">${totalFreeBottleSaving}</span>
                  <span class="free-badge">FREE</span>
                </div>
              </div>
            </div>`;
          }

          /* The V4.7 Subscribe & Save gifts (2026-10-14). Values and photos
             match the 4.7 page's first-order list; the frother is named
             "Premium Frother" here (on request), after its product. Drawn only when checkout will add
             them -- giftAddable reads the same flags giftLineItems does. */
          [
            { qty: totalPremiumFrother, flag: 'premiumFrotherOOS', cls: 'premium-frother', name: 'Premium Frother', value: '$15',
              img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Silver_Frother_cutout.png?v=1790846917&width=200' },
            { qty: totalCap, flag: 'capOOS', cls: 'cap', name: 'Premium Hat', value: '$35',
              img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/fon-premium-hat-white.webp?v=1790725962&width=200' }
          ].forEach(function (g) {
            if (!(g.qty > 0) || !FonCartDrawer.giftAddable(g.flag)) return;
            html += `
            <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-${g.cls}-row">
              <div class="fon-line-item fon-line-item-free-${g.cls}" data-total="${g.qty}">
                <div class="image">
                  <img class="img-fluid" src="${g.img}" alt="Free ${g.name}">
                </div>
                <div class="text">
                  <h3>Free ${g.qty}x ${g.name}</h3>
                  <p class="packaging">
                    <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
                    <span>Free gift for subscribers</span>
                  </p>
                </div>
                <div class="action">
                  <span class="free-saving">${g.value}</span>
                  <span class="free-badge">FREE</span>
                </div>
              </div>
            </div>`;
          });
          // if (totalFrother > 0 && !frotherOOS){

          // var totalFreeFrotherSaving = totalFrother * frotherPrice;
          // html += `
          //   <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-frother-row">
          //     <div class="fon-line-item fon-line-item-free-frother" data-total="${totalFrother}">
          //       <div class="image">
          //         <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON-FROTHER-NO-BG_100x.png?v=1760415588" alt="Free Frother">
          //       </div>
          //       <div class="text">
          //         <h3>Free ${totalFrother}x <strong>FON</strong> Frother</h3>    
          //         <p class="packaging">
          //           <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
          //           <span>Free gift for subscribers</span>
          //         </p>
          //       </div>
          //       <div class="action">
          //         <span class="free-saving with-currency-code">${totalFreeFrotherSaving}</span>
          //         <span class="free-badge">FREE</span>
          //       </div>
          //     </div>
          //   </div>`;
          // }


          // For Frother Savings
          if (totalOLBottle > 0 && !bottleOOS){

            var totalFreeBottleSaving = totalOLBottle * bottlePrice;
            html += `
              <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-bottle-row">
                <div class="fon-line-item fon-line-item-free-bottle-onelife" data-total="${totalOLBottle}">
                  <div class="image">
                    <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x.png?v=1779342543" alt="Free Bottle">
                  </div>
                  <div class="text">
                    <h3>Free ${totalOLBottle}x Premium Bottle</h3>    
                    <p class="packaging">
                      <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
                      <span>Free gift for subscribers</span>
                    </p>
                  
                  </div>
                  <div class="action">
                    <span class="free-saving with-currency-code">${totalFreeBottleSaving}</span>
                    <span class="free-badge">FREE</span>
                  </div>
                </div>
              </div>`;
          }

          // if (totalOLFrother > 0 && !frotherOOS){

          // var totalFreeFrotherSaving = totalOLFrother * frotherPrice;
          // html += `
          //   <div class="fon-line-item-free-row fon-line-item-wrapper fon-line-item-row fon-line-item-free-frother-row">
          //     <div class="fon-line-item fon-line-item-free-frother-onelife" data-total="${totalOLFrother}">
          //       <div class="image">
          //         <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON-FROTHER-NO-BG_100x.png?v=1760415588" alt="Free Frother">
          //       </div>
          //       <div class="text">
          //         <h3>Free ${totalOLFrother}x <strong>FON</strong> Frother</h3>    
          //         <p class="packaging">
          //           <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/tag.png?v=1763438739"/>
          //           <span>Free gift for subscribers</span>
          //         </p>
          //       </div>
          //       <div class="action">
          //         <span class="free-saving with-currency-code">${totalFreeFrotherSaving}</span>
          //         <span class="free-badge">FREE</span>
          //       </div>
          //     </div>
          //   </div>`;
          // }
          // For Frother Savings

          if (totalWSWelcomeKit > 0){
          html += `
            <div class="fon-line-item-wrapper fon-line-item-row fon-line-item-free-ws-welcome-kit-row">
              <div class="fon-line-item fon-line-item-ws-welcome-kit" data-total="${totalWSWelcomeKit}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FONPlaceholder.png?v=1759774368" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>${totalWSWelcomeKit}x Wholesale Welcome Kit</h3>  
                </div>
              </div>
              </div>
            </div>`;
          }

          if (totalWSBottle > 0){
          html += `
            <div class="fon-line-item-wrapper fon-line-item-row fon-line-item-free-ws-welcome-kit-row">
              <div class="fon-line-item fon-line-item-ws-bottle" data-total="${totalWSBottle}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FONPlaceholder.png?v=1759774368" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>${totalWSBottle}x Wholesale Bottle</h3>  
                </div>
              </div>
            </div>`;
          }

          if (totalWSFrother > 0){
          html += `
            <div class="fon-line-item-wrapper fon-line-item-row fon-line-item-free-ws-welcome-kit-row">
              <div class="fon-line-item fon-line-item-ws-frother" data-total="${totalWSFrother}">
                <div class="image">
                  <img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FONPlaceholder.png?v=1759774368" alt="Free Bottle">
                </div>
                <div class="text">
                  <h3>${totalWSFrother}x Wholesale Frother</h3>  
                </div>
              </div>
            </div>`;
          }
        
        $('body').removeClass('fon-cart-drawer-empty');
        
        if (cart.items.length === 0){
          if (FonCartDrawer.isAddPending()) {
            /* An add is in flight. Leave the panel as it was rather than
               announcing an empty cart that is about to stop being empty. */
            html = '';
          } else {
            $('body').addClass('fon-cart-drawer-empty');
            html = `<div class="fon-cart-empty"><h2>Your cart is empty...</h2><a href="/collections/all" class="btn-orange">Shop now</a></div>`;
            $('body').removeClass('with-cart-items');
          }
        } else {
          /* Items arrived — the pre-emptive window is over. */
          $('body').removeClass('fon-cart-pending');
        }
        
        /* No fade. The original ran fadeOut().fadeIn() at jQuery's 400ms default —
           800ms of pure animation gating every render. Shortening it to 80/120 was
           worse, not better: hiding and restoring the panel that fast reads as a
           BLINK, where the slow version read as a cross-fade. The content is
           replaced in place instead, so there is no interval where the panel is
           empty and nothing to flash. Same markup, same result, 800ms cheaper. */
        FonCartDrawer._installRowAnimation();
        $('.fon-cart-line-items').html(html).each(function () {
          FonCartDrawer.animateUpsellBars();
        });

        /* The new line is on screen now — this is the moment to open. */
        FonCartDrawer.flushDeferredOpen();

        // if ($('.fon-line-item-row.line-item-52349173334200').length){
        //   $('.fon-clear-cart').trigger('click');
        // }
       var kitNames = ["Welcome Kit", "OneFit 90-Day Kit","OneFit Weekly Plan","OneFit Weekly Plan"];

        if (
          $('.fon-line-item h3').filter(function () {
            return kitNames.includes($(this).text().trim());
          }).length > 0
        ) {
          $('.fon-clear-cart').trigger('click');
        }


        var cartTotal = 0;
        $.each($('[data-item-final-price]'), function() {
          var val = $(this).attr('data-item-final-price');
          console.log('Value:', val); // Debug
          cartTotal += parseFloat(val) || 0; // fallback to 0 if NaN
        });
        // $('.fon-checkout-total').html('<span class="with-currency-code">' + cartTotal.toFixed(2) + '</span>');

        // $('.fon-cart-line-items').animate({ scrollTop: 0 }, 'smooth');
        // (badge already painted from this render's cart, above — no refetch)

        setTimeout( () => {
          $('body').removeClass('fon-cart-drawer-updating');
        },750);

        
      });
    }

  };

  // Optionally auto-call here (or bind later):
  $(document).ready(function () {
      // Example usage:
      FonCartDrawer.init();
      // FonCartDrawer.updateCartDrawer();
    });
  
  
    $(document).on('click', '.fon-clear-cart', function (e) {
      $('body').addClass('fon-cart-drawer-updating');
      $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json',
        success: function(cart) {
          console.log('Cart cleared:', cart);
          FonCartDrawer.updateCartDrawer();
          FonCartDrawer.updateCartItem();
        },
        error: function(xhr, status, error) {
          console.error('Error clearing cart:', error);
        }
      });


    });


  $(document).on('click', '.btn-fon-checkout', function (e) {
    e.preventDefault();
  
    $('.btn-fon-checkout').text('Checking out...');
  
    // Step 1: Get current cart
    /* force:true — same reasoning as checkoutWithGifts: this runs on the
       checkout click and posts quantity updates keyed by line key, so it must
       see the cart as it is now, not as this page last knew it. */
    FonCartDrawer.getCart(true).then(function (cart) {
      const updates = {};
      let needsUpdate = false;
  
      cart.items.forEach(item => {
        const isSubscription = item.selling_plan_allocation !== null;
        const planName = item.selling_plan_allocation?.selling_plan?.name?.toLowerCase() || '';
  
        if (isSubscription && planName.includes('12-month')) {
          if (item.quantity !== 3) {
            updates[item.key] = 3 * item.quantity;
            needsUpdate = true;
          } else {
            updates[item.key] = item.quantity;
          }
        } else {
          updates[item.key] = item.quantity;
        }
      });


      async function handleFreeGiftClear() {
        await FonCartDrawer.awaitClearFreeItems(
          [53301741289656, 51843757670584, 51793029103800,52887363551416,53301741289656,52304276357304,52304251027640,52219844985016,53491544391864,52887363551416].concat(FonCartDrawer.GIFT_EXTRA_IDS),
          'Free Gift'
        );

        // ONeLife Bottles 53301741289656,51843757670584

        // Subscribe (run code) once done
        console.log('Free items cleared!');
      //  alert('Free items cleared!');

        // e.g. trigger analytics or add new items
        proceedAfterUpdate();
      }

  
      // Step 2: Function to add free bottle or proceed to checkout
      function proceedAfterUpdate() {
        // if ($('.fon-line-item-free-bottle').length && !bottleOOS) {
        //   const quantity = $('.fon-line-item-free-bottle').attr('data-total') || 1;
  
        //   $.ajax({
        //     type: 'POST',
        //     url: '/cart/add.js',
        //     data: {
        //       id: '53301741289656', // Replace with actual free bottle variant ID
        //       quantity: quantity
        //     },
        //     dataType: 'json',
        //     success: function () {
        //       $('.btn-fon-checkout').text('Checkout');
        //       window.location.href = '/checkout';
        //     },
        //     error: function (error) {
        //       console.error('Add to cart failed', error);
        //       alert('Failed to add product to cart.');
        //     }
        //   });
        // } else {
        //   $('.btn-fon-checkout').text('Checkout');
        //   window.location.href = '/checkout';
        // }


        let itemsToAdd = [];

        // Per-bundle free gifts, from the totals computed in updateCartDrawer (see CLAUDE.md),
        // unless the cart has changed since that render (a refused add, another tab, the
        // back button). Then they come from the cart fetched above: stale totals once sent
        // the old bundle's free bottle to checkout on its own (2026-09-30).
        var gifts = FonCartDrawer._cartDiffers(cart, FonCartDrawer._drawnCart)
          ? FonCartDrawer.computeFreeGifts(cart)
          : (FonCartDrawer.freeGiftTotals || {});

        // theme.liquid does not declare bottleOOS / frotherOOS on the homepage, and a
        // bare read there throws, leaving the button on "Checking out...".
        var oosBottle  = (typeof bottleOOS  !== 'undefined') && bottleOOS;
        var oosFrother = (typeof frotherOOS !== 'undefined') && frotherOOS;

        // OneFit gifts (onefit_90d): 1 bottle + 1 frother per bundle
        if (Number(gifts.bottle) > 0 && !oosBottle) {
          itemsToAdd.push({ id: 53301741289656, quantity: Number(gifts.bottle) });
        }
        if (Number(gifts.frother) > 0 && !oosFrother) {
          itemsToAdd.push({ id: 51843757670584, quantity: Number(gifts.frother) });
        }

        // OneLife gifts (onelife_90d + comprehensive_90d): totalOLBottle / totalOLFrother.
        // Now use the regular bottle/frother variant (the OL-only shipping-name variants are retired).
        if (Number(gifts.olBottle) > 0 && !oosBottle) {
          itemsToAdd.push({ id: 53301741289656, quantity: Number(gifts.olBottle) });
        }
        if (Number(gifts.olFrother) > 0 && !oosFrother) {
          itemsToAdd.push({ id: 51843757670584, quantity: Number(gifts.olFrother) });
        }

        // V4.7 Subscribe & Save gifts (GIFT_RULES.onefit_30d.bySku), each on its own flag.
        if (Number(gifts.premiumFrother) > 0 && FonCartDrawer.giftAddable('premiumFrotherOOS')) {
          itemsToAdd.push({ id: FonCartDrawer.GIFT_VARIANTS.premiumFrother, quantity: Number(gifts.premiumFrother) });
        }
        if (Number(gifts.cap) > 0 && FonCartDrawer.giftAddable('capOOS')) {
          itemsToAdd.push({ id: FonCartDrawer.GIFT_VARIANTS.cap, quantity: Number(gifts.cap) });
        }


        //WS
        if ($('.fon-line-item-ws-welcome-kit').length) {
          const quantity = $('.fon-line-item-ws-welcome-kit').attr('data-total') || 1;
          itemsToAdd.push({
            id: 52219844985016, // Free bottle variant ID
            quantity: quantity
          });
        }
        if ($('.fon-line-item-ws-bottle').length && !oosBottle) {
          const quantity = $('.fon-line-item-ws-bottle').attr('data-total') || 1;
          itemsToAdd.push({
            id: 52304251027640, // Free bottle variant ID WS
            quantity: quantity
          });
        }
        // if ($('.fon-line-item-ws-frother').length && !frotherOOS) {
        //   const quantity = $('.fon-line-item-ws-frother').attr('data-total') || 1;
        //   itemsToAdd.push({
        //     id: 52304276357304, // Free frother variant ID WS
        //     quantity: quantity
        //   });
        // }

        // (Bundle bottle/frother add-ons are now covered by the per-bundle gift totals above.)

        if (itemsToAdd.length > 0) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: itemsToAdd }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
              $('.btn-fon-checkout').text('Checkout');
              window.location.href = '/checkout';
            },
            error: function (error) {
              console.error('Add to cart failed', error);
              alert('Failed to add product(s) to cart.');
            }
          });
        } else {
          $('.btn-fon-checkout').text('Checkout');
          window.location.href = '/checkout';
        }
      }
  
      // Step 3: Update cart first if needed
      if (needsUpdate) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            handleFreeGiftClear();
          },
          error: function (err) {
            console.error('Cart update error:', err);
            alert('Failed to update cart quantities.');
          }
        });
      } else {
        handleFreeGiftClear();
      }


    });
  });


  // Bundle  Quick Add
  $(document).on('click', '.bundle-save-products .btn-quick-add', function (e) {

  

    if ($(this).hasClass('selected')){
      $(this).removeClass('selected').html('Quick Add');
    }else{
      $(this).addClass('selected').html('Selected');

      var quantitySelector = $(this).siblings('.quick-quantity-selector');
      quantitySelector.find('.quick-quantity .quantity').attr('data-value',1).html(1);

    }

     computePrice();
    computeActiveQuantityBundle();
    
  });

  $(document).on('click', '.quick-quantity-selector .quick-btn', function (e) {

    var parent = $(this).parents('.quick-quantity-selector');
    var quantity = parent.find('.quantity');
    var label = parent.find('.label');
    var action = $(this).attr('data-action');

    var total = quantity.attr('data-value');

    switch (action){
      case 'minus':
        if (total == 1){
          total--;
          quantity.attr('data-value',0).html(0);

          let buttonDefault =  parent.siblings('button').attr('data-default');
          parent.siblings('button').removeClass('selected').html(buttonDefault);
          
        }else{
          total--;
          quantity.attr('data-value',total).html(total);
        }
      break;
      case 'plus':
        total++;
        quantity.attr('data-value',total).html(total);
      break;
    }

    if (total > 1){
      
      label.html(label.attr('data-plural'));
    }else{
      label.html(label.attr('data-singular'));
    }

    computePrice();
    computeActiveQuantityBundle();

  });



  function computePrice(){

    var totalPrice = 0;
    var quantity = 0;

    $.each($('.quick-quantity-selector .quantity'),function(){

        var price = parseFloat($(this).attr('data-variant-price'));
        var qty = parseInt($(this).attr('data-value'));

        if (qty > 0){
          totalPrice+= (price * qty);
          quantity+=qty;
        }
        
        
    });

    switch (true) {
      case quantity === 2:
        totalPrice = totalPrice * 0.95;
        break;

      case quantity === 3:
        totalPrice = totalPrice * 0.90;
        break;

      case quantity >= 4:
        totalPrice = totalPrice * 0.85;
        break;

      default:
        totalPrice = totalPrice;
    }

    if (totalPrice > 0){
      $('body').addClass('bundle-selected');
      $('#btn-add-to-cart-bundle').html(`
        <span>Add to Cart</span> -
        <strong class="add-to-cart-price with-currency-code">${totalPrice.toFixed(0)}</strong>
      `);
    }else{
      $('body').removeClass('bundle-selected');
      $('#btn-add-to-cart-bundle').html(`
        <span>Add to Cart</span>
      `);
    }
    
  }



  function computeActiveQuantityBundle(){
    
   
    
    var addToCartButtonBundle = $('#btn-add-to-cart-bundle');
    var total = 0;

    // $.each($('.bundle-save-products .btn-quick-add.selected'),function(){

    //   total+= parseFloat($(this).attr('data-quantity'));
      
    // });
    $.each($('.quick-quantity-selector .quantity'),function(){
      total+= parseFloat($(this).attr('data-value'));
    });


    $('.cart-goal,.goal-progress').removeClass('matched');
    $('.cart-goal,.goal-progress').removeClass('active');
    $('.cart-goal,.goal-progress').removeClass('last-matched');
    
    $('.cart-goal,.goal-progress').each(function (index) {
      var spendValue = parseInt($(this).attr('data-quantity'), 10);
    
      if (total >= spendValue) {
        $(this).addClass('matched'); // optional: add class to highlight
      }
    });

    var lastMatched = $('.goals .cart-goal.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it

    var lastMatched = $('.goals-progress > div.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it
    
    $(".goals,.goals-progress").attr('data-matched',$('.cart-goal').length);

    // Jan 12 - Dynamic Pricing
    $('.buying-widget-052025').removeClass('with-tier-discounts');
    if (total >= 1){
      
      var discountTier = total+1;
      discountTier = (total >= 4) ? 4 : discountTier;


      $.each($('.btn-quick-add'),function(){
        $(this).addClass('discounted-price');
        var discountedPriceValue = $(this).attr('data-variant-tier-'+discountTier+'-price');
        // $(this).append(`
        //   <span class="discounted-price-value">$${discountedPriceValue}</span>
        // `);
        $(this).find('strong').html('$'+discountedPriceValue);
      });

      $('.buying-widget-052025').addClass('with-tier-discounts'); 
    }else{
      $.each($('.btn-quick-add'),function(){
        var discountedPriceValue = $(this).attr('data-variant-price');
        $(this).removeClass('discounted-price').find('strong').html('$'+discountedPriceValue);
      });
      // $('.discounted-price-value').remove();
    }
    // Jan 12 - Dynamic Pricing -- END

    if (total > 0){
      addToCartButtonBundle.prop('disabled',false);
    }else{
      addToCartButtonBundle.prop('disabled',true);
    }
    
  }
  
  $(document).on('click', '#btn-add-to-cart-bundle', function (e) {
    addToCartBundle();
  });

  function addToCartBundle(){

    
     var addToCartButton = $('#btn-add-to-cart-bundle');
    addToCartButton.html('Please wait..').prop('disabled',true);
        var items = [];
    

    $.each($('.quick-quantity-selector .quantity'),function(){

      var variantId = $(this).data('variant-id');
      var qty =  parseFloat($(this).attr('data-value'));
    
      if (variantId && qty > 0) {
        items.push({
          id: variantId,
          quantity: qty
        });
      }
    });
    // $.each($('.bundle-save-products .btn-quick-add.selected'),function(){
    //   var variantId = $(this).data('variant-id');
    //   var qty = 1;
      
    //   if (variantId) {
    //     items.push({
    //       id: variantId,
    //       quantity: qty
    //     });
    //   }
    // });
    
    if (items.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: items
        },
        dataType: 'json',
        success: function(response) {
          console.log('Items added:', response);

          FonCartDrawer.openCartDrawer();
          FonCartDrawer.updateCartDrawer();
          addToCartButton.html('Add To Cart').prop('disabled',false);
          computePrice();
          
          
        },
        error: function(error) {
          console.error('Error adding items:', error);
          addToCartButton.html('Something went wrong...').prop('disabled',false);
        }
      });
    }
  }
  
  

  $(document).on('click', '.fbt-add-to-cart', function (e) {
    e.preventDefault();
  
    var $button = $(this);
    var variantId = $button.data('variant-id');
  
    // Prevent multiple clicks
    if ($button.prop('disabled')) return;
  
    $button.prop('disabled', true).addClass('loading');
    


    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function (response) {
        console.log('Added to cart:', response);
        FonCartDrawer.updateCartDrawer();
        $button.html('<img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Check_Icon_Orange.svg?v=1753423498"> Added').addClass('added');

        setTimeout(function(){
          $button.html('<img loading="lazy" alt="Add product" title="Add product" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Add_Icon_f2a35214-c368-4713-bb4f-e27a9344e6c8.svg?v=1783643682">').removeClass('added').prop('disabled', false);
        },2000);
      },
      error: function (error) {
        console.error('Add to cart error:', error);
        alert('Sorry, could not add this item.');
        $button.prop('disabled', false).removeClass('loading');
      }
    });
  });

  $(document).on('click', '.fon-line-item .image img, .fon-line-item h3', function() {
    // Find the closest .fon-line-item container
    var item = $(this).closest('.fon-line-item');
    
    // Get the data-url attribute
    var url = item.data('url');

    // Redirect if the URL exists
    if (url) {
        window.location.href = url;
    }
  });


 
  $(document).on('click', '.fon-cross button', async function () {

    // The add-to-cart payload is rendered server-side by Liquid into data-add-items
    // (see fon-cart-drawer-v2.liquid). No productSellingPlanData / registry lookup.
    const $card = $(this).closest('.fon-cross');
    let items = [];
    try {
      items = JSON.parse($card.attr('data-add-items') || '[]');
    } catch (e) {
      console.error('Invalid data-add-items on cross-sell card:', e);
    }

    if (!items.length) {
      console.error('Cross-sell card has no items to add.');
      return;
    }

    // Conversion tracking: lands on the order's line items (hidden at checkout)
    var crossFrom = $card.attr('data-context') || 'bundle';
    FonCartDrawer.trackEvent('cart_drawer_offer_click', { offer: 'cross-sell-complete-system', from_product: crossFrom });
    items.forEach(function (it) {
      it.properties = Object.assign({}, it.properties, {
        _cart_drawer_action: 'cross-sell-complete-system',
        _cart_drawer_description: 'upgraded ' + crossFrom + ' bundle to Complete System 90-Day Supply via cart drawer'
      });
    });

    // 'duo' just adds one more complete system on top; every other context is a
    // clear-then-add (the shopper is upgrading their single bundle to the system).
    const isDuo = $card.attr('data-context') === 'duo';

    const $btn = $(this).prop('disabled', true);

    try {
      /* Duo: the shopper already has a Complete System. Don't add the card's
         payload — it's baked from the first OF- variant at render time, so it
         would land as a SECOND group in the default flavour. Just take the group
         they have to quantity + 1, exactly as the row's "+" button does.
         updateCartBundleItem() edits the existing lines by key and refreshes the
         drawer itself. */
      if (isDuo) {
        const cart = await FonCartDrawer.getCart();
        const anchor = (cart.items || []).find(function (i) {
          return i.properties
            && i.properties._BUNDLE === 'comprehensive_90d'
            && i.properties._bundle_group_id
            && String(i.properties._bundle_group_product_row) === '1';
        });

        if (anchor) {
          const mult = parseInt(anchor.properties._bundle_group_product_multiplier) || 5;
          const unitQty = Math.round(anchor.quantity / mult);
          FonCartDrawer.updateCartBundleItem(anchor.properties._bundle_group_id, unitQty + 1, mult);
          FonCartDrawer.trackEvent('cart_drawer_conversion', {
            drawer_action: 'cross-sell-duo',
            from_product: 'complete system',
            to_product: 'complete system +1'
          });
          FonCartDrawer.openCartDrawer();
          $btn.prop('disabled', false);
          return;
        }
        // No group to bump (shouldn't happen — 'duo' only shows when one exists).
        console.warn('[cross-sell] duo: no comprehensive_90d group found, adding instead');
      }

      /* Upgrade contexts replace what the cart holds, but only once the new
         bundle is in. This used to /cart/clear.js first: when Shopify refused
         the add (a sold-out flavour, 2026-09-30) the shopper was left with an
         empty cart under a drawer still drawing the old one, and FINISH MY
         ORDER then added the old bundle's free bottle on its own. Adding first
         means a refused add changes nothing. */

      // 1. Note the lines to replace (forced: the cache may be stale)
      const before = isDuo ? null : await FonCartDrawer.getCart(true);

      // 2. Add the bundle (items built by Liquid)
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
        FonCartDrawer.invalidateCart();  /* fetch() bypasses the ajax hook */
      if (!res.ok) throw new Error(await res.text());
      const added = await res.json();

      // 3. Remove what was there before. A key the add just wrote is kept, in
      //    case a new line merged into an old one.
      if (before && (before.items || []).length) {
        const keep = {};
        (added.items || []).forEach(function (i) { keep[i.key] = true; });
        const updates = {};
        before.items.forEach(function (i) { if (!keep[i.key]) updates[i.key] = 0; });
        if (Object.keys(updates).length) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          FonCartDrawer.invalidateCart();  /* fetch() bypasses the ajax hook */
        }
      }

      FonCartDrawer.trackEvent('cart_drawer_conversion', {
        drawer_action: 'cross-sell-complete-system',
        from_product: crossFrom + ' bundle',
        to_product: 'Complete System 90-Day Supply'
      });

      // 4. Refresh drawer
      FonCartDrawer.openCartDrawer();
      FonCartDrawer.updateCartDrawer();

    } catch (err) {
      console.error('Failed:', err);
      // Redraw from the server so the drawer (and its gift totals) match the
      // cart as it really is.
      FonCartDrawer.updateCartDrawer();
    }

    $btn.prop('disabled', false);
  });


  // Line-item upsell: replace the try-once item with the 90-day subscription bundle.
  $(document).on('click', '.fon-upsell__cta', async function () {

    const $card = $(this).closest('.fon-upsell');
    const lineKey = $card.attr('data-line-key');
    const bundleGroupId = $card.attr('data-bundle-group-id');
    let items = [];
    try {
      items = JSON.parse($card.attr('data-add-items') || '[]');
    } catch (e) {
      console.error('Invalid data-add-items on upsell card:', e);
    }

    if ((!lineKey && !bundleGroupId) || !items.length) {
      console.error('Upsell card missing line key / bundle group or items.');
      return;
    }

    // Conversion tracking: lands on the order's line items (hidden at checkout)
    var upsellFrom = $card.attr('data-from-desc') || 'one-time purchase';
    FonCartDrawer.trackEvent('cart_drawer_offer_click', { offer: 'upsell-90-day', from_product: upsellFrom });
    items.forEach(function (it) {
      it.properties = Object.assign({}, it.properties, {
        _cart_drawer_action: 'upsell-90-day',
        _cart_drawer_description: 'upgraded ' + upsellFrom + ' to 90-day subscription via cart drawer'
      });
    });

    const $btn = $(this).prop('disabled', true);
    $('body').addClass('fon-cart-drawer-updating');

    try {
      /* Add first, remove after — same reason as the cross-sell above: when
         the removal went first, a refused add lost the shopper's line. */

      // 1. The line(s) to replace. For a bundle, every line sharing the bundle
      //    group id; otherwise the single try-once line.
      let keysToRemove = [];
      if (bundleGroupId) {
        const cart = await FonCartDrawer.getCart();
        keysToRemove = (cart.items || [])
          .filter(i => i.properties && i.properties._bundle_group_id === bundleGroupId)
          .map(i => i.key);
      } else {
        keysToRemove = [lineKey];
      }

      // 2. Add the 90-day subscription bundle
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
        FonCartDrawer.invalidateCart();  /* fetch() bypasses the ajax hook */
      if (!res.ok) throw new Error(await res.text());
      const added = await res.json();

      // 3. Remove the replaced line(s), keeping any key the add just wrote.
      const keep = {};
      (added.items || []).forEach(function (i) { keep[i.key] = true; });
      for (const k of keysToRemove) {
        if (keep[k]) continue;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: k, quantity: 0 })
        });
        FonCartDrawer.invalidateCart();  /* fetch() bypasses the ajax hook */
      }

      FonCartDrawer.trackEvent('cart_drawer_conversion', {
        drawer_action: 'upsell-90-day',
        from_product: upsellFrom,
        to_product: '90-day subscription'
      });

      // 4. Refresh drawer
      FonCartDrawer.updateCartDrawer();

    } catch (err) {
      console.error('Upsell switch failed:', err);
      $('body').removeClass('fon-cart-drawer-updating');
      $btn.prop('disabled', false);
      FonCartDrawer.updateCartDrawer();  // redraw the cart as it really is
    }
  });


})(jQuery);
